$(document).ready(function () {
  if (localStorage.getItem("RedirectionOnCheckOutPage") == "true") {
    clearcart();
    $('.header-cart .cart-summary').remove();
    $('.header-cart .header-cart__count').text(0);
    localStorage.setItem("RedirectionOnCheckOutPage", "false");
  }

  // Bundle Size variant: update header price when a size is picked.
  // The bundle uses cstm-variant-picker (no <variant-picker> wrapper), so
  // Boost's variant-change handler doesn't run here. Each radio carries the
  // formatted price in `variant_price="…"` (assigned in cstm-variant-picker.liquid).
  // The picker renders outside the <form>, so we also sync the form's
  // `select[name="id"]` to the chosen variant id — otherwise serializeArray()
  // submits the default variant on add to cart.
  $(document).on('change', '.option-selector__btns input[type="radio"][variant_price]', function () {
    var price = $(this).attr('variant_price');
    if (price) {
      $('[data-product-detail-price] .theme-money').html(price);
    }
    var variantId = $(this).attr('data-variant-id');
    if (variantId) {
      $('form[action*="/cart/add"] select[name="id"], form[action*="/cart/add"] input[name="id"]').val(variantId);
    }
  });

  // --- Bundle target "ceiling" ---------------------------------------------
  // The largest tier a shopper explicitly clicks sticks as a minimum goal (and
  // persists across reloads), so selecting "50+" then Mystery Fill completes all
  // the way to 50 instead of the count silently downgrading the target.
  var bundleCeiling = parseInt(localStorage.getItem('bundleCeiling')) || 0;
  var bundleDownsizeTarget = 0; // set when a shopper picks a size SMALLER than the current count

  // ---- Tier config: SINGLE SOURCE OF TRUTH -------------------------------
  // Tier quantities + prices are read from the Size radios in the DOM, so a
  // variant rename (e.g. "30 Wigglitz" -> "36 Wigglitz") or a price change in
  // the store flows through every tier reference here AUTOMATICALLY — no code
  // edit needed on reprice day. Falls back to the legacy 6/15/30/50 lineup if
  // the radios can't be parsed.
  // FLIP DAY: BB_EXTRA_EACH is the ONE number to edit by hand — it must equal
  // the store price of the per-unit "Additional Wigglitz (Beyond 50)" product
  // (variant 53639873921338) that bills the portion of a bundle beyond 50.
  // Flipped 1.20 -> 1.50 on 2026-07-02 with the new pricing launch.
  var BB_EXTRA_EACH = 1.33; // ARM B OFFER 6 (2026-08-26): beyond-64 rate; extras variant __BEYOND64_ID__
  // Shared running count. Was an IMPLICIT global only assigned inside
  // totalCountSelection() — the very first size-box click on a fresh page read it
  // before any assignment and threw an uncaught ReferenceError (skipping that
  // handler's nextTarget() call). Declared here so it always exists.
  var totalQuantity = 0;
  var bbTierCache = null;
  // Gen-1 lineup ONLY (2026-08-20): the Offer-4 test variants (6-Pack/20/32/65) sit
  // hidden in this page's DOM for the B test theme - without this filter the scan
  // sees 8 Size values, the length===4 check fails, and every tier lookup falls to
  // the stale legacy fallback (wrong sizes AND wrong prices in the upsell copy).
  var BB_TIER_VALUES = ['7 Wigglitz', '20 Wigglitz', '32 Wigglitz', '64 Wigglitz']; // ARM B OFFER 6 (2026-08-28: bottom tier 7/$19.99)
  function bbTiers() {
    if (bbTierCache) { return bbTierCache; }
    var list = [];
    $('.option-selector__btns input[value$="Wigglitz"]').each(function () {
      if (BB_TIER_VALUES.indexOf(String($(this).val() || '')) === -1) { return; }
      var q = parseInt($(this).val(), 10);
      if (!q) { return; }
      var dupe = false;
      for (var i = 0; i < list.length; i++) { if (list[i].q === q) { dupe = true; break; } }
      if (dupe) { return; }
      var p = parseFloat(($(this).attr('variant_price') || '').replace(/[^0-9.]/g, ''));
      list.push({ q: q, price: isNaN(p) ? 0 : p });
    });
    list.sort(function (a, b) { return a.q - b.q; });
    if (list.length === 4) { bbTierCache = list; return list; }
    return [{ q: 7, price: 19.99 }, { q: 20, price: 32.99 }, { q: 32, price: 49.99 }, { q: 64, price: 84.99 }];
  }
  function bbTierQ(i) { return bbTiers()[i].q; }

  function bundleCountTier(n) {
    if (n <= bbTierQ(0)) return bbTierQ(0);
    if (n <= bbTierQ(1)) return bbTierQ(1);
    if (n <= bbTierQ(2)) return bbTierQ(2);
    return bbTierQ(3);
  }
  function bundleEffectiveTier(n) {
    // During an explicit downsize, hold the smaller chosen size as the target so
    // the old tier logic and the reconciler agree (no churn). Cleared in
    // reconcileBundleButton once the count drops to the smaller size.
    if (bundleDownsizeTarget > 0 && n > bundleDownsizeTarget) { return bundleDownsizeTarget; }
    var t = bundleCountTier(n);
    if ((bundleCeiling || 0) > t) { t = bundleCeiling; }
    if (t > bbTierQ(3)) { t = bbTierQ(3); }
    return t;
  }
  function bundleCurrentCount() {
    var c = 0; $('.ITG_Product_description .qtybox input').each(function () { c += parseInt($(this).val()) || 0; }); return c;
  }
  $(document).on('click', '.option-selector__btns label', function () {
    // A genuine tap on a size box sets the ceiling. nextTarget()'s programmatic
    // clicks target the radio input (not the label), so they don't trigger this.
    var forId = $(this).attr('for');
    var inp = forId ? document.getElementById(forId) : null;
    var n = parseInt(((inp ? inp.value : '') || '').replace(/[^0-9]/g, '')) || 0;
    if (!n) return;
    bundleCeiling = n; localStorage.setItem('bundleCeiling', n);
    // Picking a size smaller than what's already in the bundle = a downsize:
    // hold that smaller size as the goal and prompt them to remove (or upsize).
    // Exception: the top (50+) tier is "50 OR MORE", so clicking it while
    // holding 53 is already satisfied — never treat that as a downsize.
    bundleDownsizeTarget = (n < bundleCurrentCount() && n < bbTierQ(3)) ? n : 0;
  });
  // Clickable progress circles: change the size IN PLACE. We deliberately do NOT
  // click the size box at the top (that focuses a radio up there and the browser
  // jumps the page to it). Instead we set the goal and let reconcile update the
  // box / price / button without moving the scroll position.
  $(document).on('click', '#create-your-bundle .progress-bar .dot', function (e) {
    var v = parseInt($(this).attr('data-value')) || 0;
    if (!v) return; // the "0" circle does nothing
    if (e && e.preventDefault) { e.preventDefault(); }
    var keepY = (window.pageYOffset || document.documentElement.scrollTop || 0);
    bundleCeiling = v; localStorage.setItem('bundleCeiling', v);
    bundleDownsizeTarget = (v < bundleCurrentCount() && v < bbTierQ(3)) ? v : 0;
    reconcileBundleButton();
    // Hard guarantee: pin the scroll position across this tick + the next few
    // frames so NOTHING can jump the page when a size circle is tapped.
    var pin = function () { window.scrollTo(0, keepY); };
    pin();
    if (window.requestAnimationFrame) { requestAnimationFrame(pin); }
    setTimeout(pin, 0); setTimeout(pin, 60); setTimeout(pin, 150);
  });
  // Adding (a "+" on a row, or adding a new character) means they're growing the
  // bundle, so exit any downsize — it should auto-upgrade to the next size as they
  // fill, and re-open Add to Cart once they reach a size (e.g. back up to 50).
  $(document).on('click', '#create-your-bundle .DefaultAddBtn, #create-your-bundle .ITGQtyAdjust.qtyplus', function () {
    bundleDownsizeTarget = 0;
  });
  // Helper-prompt copy: celebrate once the shopper reaches the best-value 50+ tier.
  var bundleHeadingOriginalHTML = $('.bundle-sidebar__heading').html();
  var bundleHeadingMode = 'normal';
  var BUNDLE_CONGRATS_HTML = "You're getting the best possible deal, add as many as you want!";
  // Single source of truth for the Add-to-Cart button + which variant is charged.
  // Runs after every builder interaction so price / size / count can never desync.
  function reconcileBundleButton() {
    if (!$('#create-your-bundle').length) return;
    var count = bundleCurrentCount();
    // 65+ is handled by updateCartButton (per-unit pricing) — EXCEPT during an
    // explicit downsize. Above the top tier, snapping the selection back made
    // clicking a smaller size box look dead. A real downsize falls through to
    // the normal "remove N to fit" flow.
    if (count > bbTierQ(3) && bundleDownsizeTarget <= 0) return;
    // Exit "downsize" once they've removed enough to reach the smaller size.
    if (bundleDownsizeTarget > 0 && count <= bundleDownsizeTarget) { bundleDownsizeTarget = 0; }
    var target = (bundleDownsizeTarget > 0) ? bundleDownsizeTarget : bundleEffectiveTier(count);
    var $r = $('.option-selector__btns input[value="' + target + ' Wigglitz"]');
    // Keep the charged variant, the selected box, the highlighted circle and the
    // counter all pointing at the target.
    var id = $r.attr('data-variant-id');
    if (id) { $('form[action*="/cart/add"] select[name="id"], form[action*="/cart/add"] input[name="id"]').val(id); }
    $('.option-selector__btns input[type="radio"]').prop('checked', false);
    $r.prop('checked', true);
    $('[data-product-detail-price] .theme-money').html($r.attr('variant_price') || '');
    $('.dot').removeClass('highlight');
    $('.dot[data-value="' + target + '"]').addClass('highlight');
    $('span.count_select').text(target);
    // Clear sidebar messaging (the 65+ "best deal" copy is handled by updateCartButton).
    if (count < bbTierQ(3) || bundleDownsizeTarget > 0) {
      if (count > target) {
        $('.bundle-sidebar__heading').html('Please upgrade to a larger size, or remove ' + (count - target) + ' Wigglitz.');
      } else if (count < target) {
        if (count > 0) {
          // Goal-gradient nudge: people push harder the closer they are to the goal.
          $('.bundle-sidebar__heading').html('Just ' + (target - count) + " more to finish your " + target + "-pack — or hit 'Mystery Fill'!");
        } else {
          $('.bundle-sidebar__heading').html("Please select at least " + target + " Wigglitz, or hit 'Mystery Fill' to make the rest a surprise!");
        }
      } else {
        $('.bundle-sidebar__heading').html('Your ' + target + ' Wigglitz bundle is ready!');
      }
    }
    if (count === target) {
      $('.custom-add-to_cart').addClass('add-to_cart-disabled').text('Add to Cart - ' + $r.attr('variant_price'));
      $('.Srm-quantity_box-add').hide(); $('.Srm_desk_qty').show();
    } else if (count < target) {
      $('.custom-add-to_cart').removeClass('add-to_cart-disabled').html('<span>Please select at least ' + target + ' products</span>');
      $('.Srm-quantity_box-add').show(); $('.Srm_desk_qty').hide();
    } else {
      $('.custom-add-to_cart').removeClass('add-to_cart-disabled').html('<span>Please upgrade to a larger size, or remove ' + (count - target) + ' Wigglitz</span>');
      $('.Srm-quantity_box-add').show(); $('.Srm_desk_qty').hide();
    }
    bbDeskSync();
  }

  // ===== DESKTOP-ONLY: always-on Add-to-Cart button + helper line (2026-07-06, Zack).
  // Desktop used to swap the button for a black "please select N products" pill, so shoppers
  // never saw a grayed-out Add to Cart and didn't know why the bundle wasn't addable. Mirror
  // the mobile pattern: the button is ALWAYS present, grayed until the count hits a valid size,
  // with a short helper line underneath. Reaching ANY valid size (6/15/36/50+) enables it — even
  // if a bigger size was tapped — with a "keep collecting" nudge toward the next reward.
  // MONEY-SAFE: enabling just sets that reached size and fires the real .custom-add-to_cart add
  // flow (same safety net that refuses any count/variant mismatch). Mobile is untouched — this
  // block is display:none below 768px and #bb-stickybar keeps driving mobile.
  // Currency-safe money parse: handles "$60.00", "€67,95", "1.234,56" and "1,234.56"
  // (the naive strip-non-digits turned "€67,95" into 6795). Used for the 50+ per-unit total.
  function bbMoneyToNum(s) {
    s = (s || '').replace(/[^0-9.,]/g, '');
    if (s.indexOf('.') > -1 && s.indexOf(',') > -1) {
      s = (s.lastIndexOf(',') > s.lastIndexOf('.')) ? s.replace(/\./g, '').replace(',', '.') : s.replace(/,/g, '');
    } else if (s.indexOf(',') > -1) {
      s = /,\d{2}$/.test(s) ? s.replace(/\./g, '').replace(',', '.') : s.replace(/,/g, '');
    }
    return parseFloat(s) || 0;
  }
  // Count-based checkout button state (ceiling-agnostic): { ready, price } at the reached size.
  // Shared by the desktop button AND the mobile sticky bar so BOTH enable checkout the moment the
  // count lands on a full size (6/15/36) or 50+, even if a bigger size box was tapped.
  function bbTierBtn(count) {
    var T = bbTiers();
    var q = [T[0].q, T[1].q, T[2].q, T[3].q];
    function priceOf(n) { return $('.option-selector__btns input[value="' + n + ' Wigglitz"]').attr('variant_price') || ''; }
    if (count >= q[3]) {
      var base = bbMoneyToNum(priceOf(q[3])) || T[3].price;
      var each = (typeof BB_EXTRA_EACH !== 'undefined') ? BB_EXTRA_EACH : 1.2;
      return { ready: true, price: '$' + (base + (count - q[3]) * each).toFixed(2) };
    }
    var idx = (count === q[0]) ? 0 : (count === q[1]) ? 1 : (count === q[2]) ? 2 : -1;
    if (idx > -1) { return { ready: true, price: priceOf(q[idx]) }; }
    return { ready: false, price: '' };
  }
  // Money-safe "add at the reached size": snap the checkout size to the current count so the
  // charged variant matches it, then fire the real, safety-netted .custom-add-to_cart add. Shared
  // by the desktop button and the mobile bar — reuses the existing add flow, no pricing rewrite.
  function bbCheckoutReached() {
    var count = bundleCurrentCount();
    var T = bbTiers();
    if (count >= T[3].q) {
      if (typeof updateCartButton === 'function') { updateCartButton(count); }   // 50+ per-unit + ready state
    } else {
      bundleCeiling = count;
      try { localStorage.setItem('bundleCeiling', count); } catch (e) {}
      bundleDownsizeTarget = 0;
      reconcileBundleButton();                                                    // marks the reached size ready + sets the form id
    }
    var m = document.querySelector('.custom-add-to_cart');
    if (m && m.classList.contains('add-to_cart-disabled')) { m.click(); }
  }
  function bbDeskSync() {
    var $box = $('#create-your-bundle .bb-desk-checkout');
    if (!$box.length) return;
    var count = bundleCurrentCount();
    var tb = bbTierBtn(count);
    // 2026-09-24: honour an in-progress downsize. bbTierBtn reads the COUNT only, so
    // while the shopper sat above a tier with a smaller target it still reported "ready"
    // at the 64+ per-unit price - the button stayed live, POSTed the smaller variant with
    // too many picks, and bundle-money-guard refused it. The theme swallows that 422, so
    // the button just died. Never offer checkout while the count doesn't match the target.
    if (bundleDownsizeTarget > 0 && count !== bundleDownsizeTarget) {
      tb = { ready: false, price: '' };
    }
    $box.find('.bb-desk-atc')
      .text(tb.ready ? ('Add to Cart - ' + tb.price) : 'Add to Cart')
      .toggleClass('bb-desk-atc--off', !tb.ready);
    // Helper copy = the SAME shared goal-nudge that drives the top heading, framed for checkout.
    $box.find('.bb-desk-help').html(
      (bundleDownsizeTarget > 0 && count > bundleDownsizeTarget)
        ? ('Remove ' + (count - bundleDownsizeTarget) + ' to fit the ' + bundleDownsizeTarget + '-pack, or pick a bigger size.')
        : bbGoalMsg(count, 'button'));
  }
  $(document).on('click', '#create-your-bundle .bb-desk-atc', function () {
    if ($(this).hasClass('bb-desk-atc--off')) return;      // grayed → the helper line already explains why
    bbCheckoutReached();
  });
  setTimeout(bbDeskSync, 400);   // init once after load (covers a session-restored 50+ count)

  // Shared goal-nudge copy — ONE source of truth for both the top progress heading
  // (mode 'top', used by the sticky-bar update()) and the bottom desktop Add-to-Cart
  // helper (mode 'button'). Same live-price math (% off / free shipping / shiny), so the
  // two can never drift. 'top' reproduces the original headline; 'button' reframes it as
  // "Add N more to checkout with the <size>-pack and ...".
  function bbGoalMsg(count, mode) {
    var T = bbTiers();
    var n = [T[0].q, T[1].q, T[2].q, T[3].q];
    var ea = [];
    for (var i = 0; i < T.length; i++) { ea.push(T[i].price > 0 ? T[i].price / T[i].q : 0); }
    function offPct(i) { return (ea[0] > 0 && ea[i] > 0) ? Math.round((ea[0] - ea[i]) / ea[0] * 100) : 0; }
    var idx = -1;
    for (var t = 0; t < n.length; t++) { if (count < n[t]) { idx = t; break; } }
    var forBtn = (mode === 'button');
    if (idx < 0) {
      // ARM B top tier: TWO bonus Shinies.
      return "You're getting the <b>best possible deal</b>: TWO guaranteed SHINY Wigglitz + Free Shipping! Add as many as you want!";
    }
    var addN = n[idx] - count;
    var lead = forBtn ? ('Add ' + addN + ' more to checkout with the ' + n[idx] + '-pack') : ('Add ' + addN + ' more to get');
    if (idx === 0) {
      if (forBtn) { return (count < 1) ? ('Pick at least ' + n[0] + ' Wigglitz to build a bundle') : ('Add ' + addN + ' more to reach the ' + n[0] + '-pack'); }
      return 'Add at least ' + n[0] + ' Wigglitz';
    }
    if (idx === 1) {
      // ARM B OFFER 6 (2026-08-26): the 20-pack adds ONE free bonus Wigglitz.
      // It does NOT ship free any more — free shipping now starts at the 32-pack.
      var save = offPct(1);
      if (save >= 3) { return forBtn ? (lead + ' and save ' + save + '% plus a BONUS Wigglitz') : ('Add ' + addN + ' more to save ' + save + '% plus a BONUS Wigglitz'); }
      return forBtn ? (lead + ' and get a BONUS Wigglitz') : ('Add ' + addN + ' more to get a BONUS Wigglitz');
    }
    if (idx === 2) {
      // ARM B: the 32-pack carries the first guaranteed Shiny.
      var off2 = offPct(2);
      if (off2 >= 3) { return forBtn ? (lead + ' and get ' + off2 + '% off, a guaranteed SHINY Wigglitz plus FREE SHIPPING') : ('Add ' + addN + ' more to get ' + off2 + '% off, a guaranteed SHINY Wigglitz plus FREE SHIPPING'); }
      return forBtn ? (lead + ' and get a guaranteed SHINY + FREE SHIPPING') : ('Add ' + addN + ' more to get a guaranteed SHINY + FREE SHIPPING');
    }
    // ARM B: the 65-pack guarantees TWO Shinies.
    var off3 = offPct(3);
    if (off3 >= 3) { return forBtn ? (lead + ' and get ' + off3 + '% off, TWO guaranteed SHINY Wigglitz plus FREE SHIPPING') : ('Add ' + addN + ' more to get ' + off3 + '% off, TWO guaranteed SHINY Wigglitz plus FREE SHIPPING'); }
    return forBtn ? (lead + ' and get TWO guaranteed SHINYs + FREE SHIPPING') : ('Add ' + addN + ' more to get TWO guaranteed SHINYs + FREE SHIPPING');
  }
  $(document).on('click', '#create-your-bundle .option-selector__btns label, #create-your-bundle .progress-bar .dot, #create-your-bundle .DefaultAddBtn, #create-your-bundle .ITGQtyAdjust, #create-your-bundle .random-button, #create-your-bundle .itg_remove', function () {
    setTimeout(reconcileBundleButton, 90);
    setTimeout(bbDeskSync, 110);           // keep the desktop always-on button in sync (covers the 50+ path where reconcile early-returns)
  });
  /* ==========================================================================
     DOWNSIZE SHEET (2026-09-24)
     Tapping a size SMALLER than what's already picked used to leave the page in
     a split state: the tile and the charged variant moved to the small size, the
     sidebar correctly said "remove N", but the big Add-to-Cart button kept the
     64+ per-unit price and stayed live. Tapping it POSTed the small variant with
     too many picks, bundle-money-guard refused it (422), and the theme's ajax
     error handler swallows the body - so the button simply did nothing. Dead end,
     no message, on BOTH arms.
     Now: intercept the tap BEFORE the radio moves and let them choose what goes.
     ======================================================================== */
  var BB_SEQ = 0;                 // insertion order, so "the last N I added" is real
  var bbSheetTarget = 0;          // tier they're trying to move to while the sheet is open

  function bbStampCard($card) { if ($card && $card.length) { $card.attr('data-bb-seq', ++BB_SEQ); } }
  $(document).on('click', '#create-your-bundle .DefaultAddBtn, #create-your-bundle .ITGQtyAdjust.qtyplus', function () {
    bbStampCard($(this).closest('.product-block.col_bundle_sec'));
  });

  // Every character currently in the bundle, NEWEST FIRST. Duplicates stay stacked
  // (one entry carrying qty) so 108 picks don't render 108 tiles.
  function bbPicks() {
    var out = [];
    $('#create-your-bundle .product-block.col_bundle_sec').each(function () {
      var $c = $(this);
      var q = parseInt($c.find('.qtybox input').val()) || 0;
      if (q < 1) { return; }
      var $b = $c.find('.DefaultAddBtn').first();
      out.push({
        handle: $c.attr('data-id') || '',
        title: ($b.attr('title') || $c.find('.ci-name').first().text() || 'Wigglitz').trim(),
        img: $b.attr('data_img') || '',
        qty: q,
        seq: parseInt($c.attr('data-bb-seq')) || 0
      });
    });
    out.sort(function (a, b) { return (b.seq - a.seq) || a.title.localeCompare(b.title); });
    return out;
  }

  // Remove ONE unit, through the theme's own adjustQty so the sidebar row, the
  // hidden line-item field and localStorage all stay in step.
  function bbRemoveOne(handle) {
    var $m = $('#create-your-bundle .product-block.col_bundle_sec[data-id="' + handle + '"] .qtybox [btnfor="minus"]').first();
    if (!$m.length) { return false; }
    adjustQty($m);
    return true;
  }

  // Remove n units, newest first. nextTarget() is suppressed across the loop (it
  // re-scans every card) and run once at the end - same trick "Add All" uses.
  function bbRemoveNewest(n) {
    var saved = nextTarget;
    nextTarget = function () {};
    try {
      var left = n, guard = 0;
      while (left > 0 && guard++ < 5000) {
        var picks = bbPicks();
        if (!picks.length) { break; }
        var take = Math.min(left, picks[0].qty);
        for (var i = 0; i < take; i++) { if (!bbRemoveOne(picks[0].handle)) { left = 0; break; } }
        left -= take;
      }
    } finally { nextTarget = saved; }
    nextTarget();
  }

  function bbSheetEl() {
    var el = document.getElementById('bb-downsize');
    if (el) { return $(el); }
    $('head').append(
      '<style id="bb-downsize-css">' +
      '#bb-downsize{position:fixed;inset:0;z-index:100000;display:none;align-items:flex-end;justify-content:center;background:rgba(0,0,0,.45)}' +
      '#bb-downsize.is-open{display:flex}' +
      '#bb-downsize .bb-ds-card{background:#fff;width:100%;max-width:620px;border-radius:18px 18px 0 0;padding:20px 0 16px;max-height:88vh;display:flex;flex-direction:column;box-shadow:0 -6px 34px rgba(0,0,0,.25)}' +
      '@media (min-width:768px){#bb-downsize{align-items:center}#bb-downsize .bb-ds-card{border-radius:18px}}' +
      '#bb-downsize h4{margin:0 20px 4px;font-size:20px;font-weight:800;line-height:1.25;color:#131313}' +
      '#bb-downsize .bb-ds-sub{margin:0 20px 14px;font-size:14.5px;line-height:1.45;color:#4a4a4a}' +
      '#bb-downsize .bb-ds-count{font-weight:800;color:#131313}' +
      '#bb-downsize .bb-ds-rail{display:flex;gap:10px;overflow-x:auto;padding:2px 20px 14px;-webkit-overflow-scrolling:touch;scrollbar-width:thin}' +
      '#bb-downsize .bb-ds-item{position:relative;flex:0 0 86px;text-align:center}' +
      '#bb-downsize .bb-ds-item img{width:86px;height:86px;object-fit:contain;background:#f4f7f6;border-radius:12px;display:block}' +
      '#bb-downsize .bb-ds-name{font-size:11px;line-height:1.25;margin-top:5px;color:#444;max-height:28px;overflow:hidden}' +
      '#bb-downsize .bb-ds-qty{position:absolute;left:4px;top:4px;background:#131313;color:#fff;font-size:11px;font-weight:800;border-radius:9px;padding:1px 6px}' +
      '#bb-downsize .bb-ds-x{position:absolute;right:-4px;top:-4px;width:26px;min-width:26px;height:26px;border-radius:50%;border:0;background:#131313;color:#fff;font-size:15px;line-height:26px;padding:0;cursor:pointer;font-weight:700}' +
      '#bb-downsize .bb-ds-actions{padding:0 20px;display:flex;flex-direction:column;gap:9px}' +
      '#bb-downsize .bb-ds-btn{min-width:0;width:100%;border:0;border-radius:999px;padding:14px 16px;font-size:16px;font-weight:800;cursor:pointer;line-height:1.2}' +
      '#bb-downsize .bb-ds-primary{background:#1b7f6b;color:#fff}' +
      '#bb-downsize .bb-ds-primary[disabled]{background:#cfd8d5;color:#7b8785;cursor:default}' +
      '#bb-downsize .bb-ds-ghost{background:transparent;color:#4a4a4a;font-weight:700;text-decoration:underline;padding:8px}' +
      '</style>');
    $('body').append(
      '<div id="bb-downsize" role="dialog" aria-modal="true" aria-labelledby="bb-ds-title">' +
      '  <div class="bb-ds-card">' +
      '    <h4 id="bb-ds-title"></h4>' +
      '    <p class="bb-ds-sub"></p>' +
      '    <div class="bb-ds-rail"></div>' +
      '    <div class="bb-ds-actions">' +
      '      <button type="button" class="bb-ds-btn bb-ds-primary bb-ds-quick"></button>' +
      '      <button type="button" class="bb-ds-btn bb-ds-ghost bb-ds-never">Go back to my current bundle</button>' +
      '    </div>' +
      '  </div>' +
      '</div>');
    return $('#bb-downsize');
  }

  function bbSheetRender() {
    var $s = bbSheetEl();
    var count = bundleCurrentCount();
    var target = bbSheetTarget;
    var over = count - target;
    // Copy stays plain. Never explain their own bundle back at them - "the 33-pack
    // holds 33" reads as a telling-off. Every number is derived, so this reads
    // correctly for any tier ladder and any overage.
    $s.find('h4').text('You’ve picked ' + count + ' Wigglitz');
    $s.find('.bb-ds-sub').html(
      over > 0
        ? 'Would you like to remove <span class="bb-ds-count">' + over + '</span> so you can switch to the ' + target + ' bundle?'
        : 'You’re ready to switch to the ' + target + ' bundle.'
    );
    var picks = bbPicks(), html = '';
    for (var i = 0; i < picks.length; i++) {
      var p = picks[i];
      html += '<div class="bb-ds-item" data-handle="' + p.handle + '">' +
              (p.img ? '<img src="' + p.img + '" alt="">' : '<img alt="">') +
              (p.qty > 1 ? '<span class="bb-ds-qty">×' + p.qty + '</span>' : '') +
              '<button type="button" class="bb-ds-x" aria-label="Remove one ' + p.title + '">✕</button>' +
              '<div class="bb-ds-name">' + p.title + '</div>' +
              '</div>';
    }
    $s.find('.bb-ds-rail').html(html || '<p style="padding:6px 0;color:#666">Nothing left in your bundle.</p>');
    var $q = $s.find('.bb-ds-quick');
    if (over > 0) {
      $q.text('Remove ' + over).prop('disabled', false);
    } else {
      $q.text('Switch to the ' + target + ' bundle').prop('disabled', false);
    }
  }

  function bbSheetOpen(target) {
    bbSheetTarget = target;
    bbSheetRender();
    bbSheetEl().addClass('is-open');
    $('body').addClass('bb-ds-open');
  }
  function bbSheetClose() { bbSheetEl().removeClass('is-open'); $('body').removeClass('bb-ds-open'); bbSheetTarget = 0; }

  // Commit the move: clear any downsize flag, point everything at the new tier.
  function bbSheetApply(target) {
    bundleDownsizeTarget = 0;
    bundleCeiling = target;
    try { localStorage.setItem('bundleCeiling', target); } catch (e) {}
    var $r = $('.option-selector__btns input[value="' + target + ' Wigglitz"]');
    $('.option-selector__btns input[type="radio"]').prop('checked', false);
    $r.prop('checked', true).trigger('change');
    bbSheetClose();
    reconcileBundleButton();
    bbDeskSync();
  }

  $(document).on('click', '#bb-downsize .bb-ds-x', function () {
    bbRemoveOne($(this).closest('.bb-ds-item').attr('data-handle'));
    bbSheetRender();
  });
  $(document).on('click', '#bb-downsize .bb-ds-quick', function () {
    var target = bbSheetTarget, over = bundleCurrentCount() - target;
    if (over > 0) { bbRemoveNewest(over); }
    bbSheetApply(target);
  });
  $(document).on('click', '#bb-downsize .bb-ds-never', function () { bbSheetClose(); });
  $(document).on('click', '#bb-downsize', function (e) { if (e.target && e.target.id === 'bb-downsize') { bbSheetClose(); } });

  // Intercept in the CAPTURE phase so the label never activates its radio and no
  // other handler sees the click - nothing moves until they choose.
  document.addEventListener('click', function (e) {
    if (!document.getElementById('create-your-bundle')) { return; }
    var t = e.target;
    var label = t && t.closest ? t.closest('.option-selector__btns label') : null;
    if (!label || !label.closest('#create-your-bundle')) { return; }
    var forId = label.getAttribute('for');
    var inp = forId ? document.getElementById(forId) : null;
    var n = parseInt(((inp ? inp.value : '') || '').replace(/[^0-9]/g, '')) || 0;
    if (!n) { return; }
    var count = bundleCurrentCount();
    // Only when what they've already picked genuinely does not fit. The top tier is
    // "N or more", so it always fits and never prompts.
    if (n >= bbTierQ(bbTiers().length - 1) || count <= n) { return; }
    e.preventDefault(); e.stopPropagation();
    bbSheetOpen(n);
  }, true);
  // "Add All <Collection>": state-aware bulk add. If the whole collection is already
  // in the bundle, clicking adds another of EACH (a second set). If only some are in,
  // it tops up just the missing ones. Otherwise it adds the collection. (The bottom
  // button's label tracks these states via updateAddAllButtons.) We temporarily
  // suppress the per-character recompute (slow) and run it once at the end.
  $(document).on('click', '#create-your-bundle .bundle-add-all', function () {
    var slug = $(this).attr('data-add-all');
    var $cards = $('#create-your-bundle .bundle-collection-group[data-collection="' + slug + '"] .product-block.col_bundle_sec');
    // Characters we can act on: real (not Mystery), not locked, and either addable
    // (have an add button) or already in the bundle.
    var $actionable = $cards.filter(function () {
      var $c = $(this); var h = $c.attr('data-id');
      if (!h || h === 'mystery-wigglitz') return false;
      if ($c.hasClass('product-block--locked')) return false;
      var hasBtn = $c.find('.cstm-addtocart-btn .DefaultAddBtn').length > 0;
      var q = parseInt($c.find('.qtybox input').val()) || 0;
      return hasBtn || q >= 1;
    });
    var allPresent = $actionable.length > 0 && $actionable.toArray().every(function (el) {
      return (parseInt($(el).find('.qtybox input').val()) || 0) >= 1;
    });
    var savedNextTarget = nextTarget;
    nextTarget = function () {};
    try {
      $actionable.each(function () {
        var $card = $(this);
        var q = parseInt($card.find('.qtybox input').val()) || 0;
        if (allPresent) {
          // Whole collection already in → add another of EACH (a second set).
          var $plus = $card.find('.qtybox .qtyplus, .qtybox [btnfor="plus"]').first();
          if ($plus.length) { $plus.trigger('click'); }
        } else if (q === 0) {
          // Some are missing → only add the ones not yet in (top up the set).
          var $btn = $card.find('.cstm-addtocart-btn .DefaultAddBtn');
          if ($btn.length) { $btn.trigger('click'); }
        }
        // else: partial state, this one is already in → leave it untouched.
      });
    } finally {
      nextTarget = savedNextTarget;
    }
    bundleDownsizeTarget = 0; // adding = growing the bundle
    nextTarget();
    setTimeout(reconcileBundleButton, 90);
    setTimeout(updateAddAllButtons, 95);
  });

  // Put each collection's character count on its top "Add all" sticker
  // (e.g. "+ Add all 24"). Counted from the rendered cards so it's always accurate.
  $('#create-your-bundle .bundle-collection-group').each(function () {
    var $g = $(this);
    var n = $g.find('.product-block.col_bundle_sec').filter(function () {
      return $(this).attr('data-id') !== 'mystery-wigglitz';
    }).length;
    var $top = $g.find('.bundle-add-all--top');
    if ($top.length && n > 0) { $top.text('+ Add all ' + n); }
  });

  // ---- Bottom "Add all" buttons reflect each collection's status ----
  // none in bundle  -> "Add All <Name> Wigglitz to Bundle"
  // some in bundle  -> "Add the Rest of <Name> Wigglitz"   (tops up the missing only)
  // all in bundle   -> "Add All <Name> Wigglitz Again"      (a click adds another set)
  function updateAddAllButtons() {
    $('#create-your-bundle .bundle-collection-group').each(function () {
      var $g = $(this);
      var $bot = $g.find('.bundle-add-all--bottom');
      if (!$bot.length) return;
      var $actionable = $g.find('.product-block.col_bundle_sec').filter(function () {
        var $c = $(this); var h = $c.attr('data-id');
        if (!h || h === 'mystery-wigglitz') return false;
        if ($c.hasClass('product-block--locked')) return false;
        var hasBtn = $c.find('.cstm-addtocart-btn .DefaultAddBtn').length > 0;
        var q = parseInt($c.find('.qtybox input').val()) || 0;
        return hasBtn || q >= 1;
      });
      var total = $actionable.length;
      if (!total) return;
      var present = $actionable.filter(function () {
        return (parseInt($(this).find('.qtybox input').val()) || 0) >= 1;
      }).length;
      var $pre = $bot.find('.baa-prefix');
      var $suf = $bot.find('.baa-suffix');
      $bot.removeClass('is-partial is-again');
      if (present === 0) {
        $pre.text('Add All ');
        $suf.text(' Wigglitz to Bundle');
      } else if (present < total) {
        $bot.addClass('is-partial');
        $pre.text('Add the Rest of ');
        $suf.text(' Wigglitz');
      } else {
        $bot.addClass('is-again');
        $pre.text('Add All ');
        $suf.text(' Wigglitz Again');
      }
    });
  }
  $(document).on('click', '#create-your-bundle', function () { setTimeout(updateAddAllButtons, 100); });
  updateAddAllButtons();

  // ---- Top "Add all" sticker: fade out the moment it scrolls up under the sticky
  // search bar, so it never floats over the bar or the collection dropdown. Driven by
  // IntersectionObserver (fires on the real geometry change, whatever scrolls), with a
  // window scroll/resize fallback to keep it exact. ----
  (function () {
    var tops = document.querySelectorAll('#create-your-bundle .bundle-add-all--top');
    if (!tops.length) return;
    function barH() { return (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--bb-sticky-bar-height')) || 80) + 16; }
    function apply(el) {
      var hide = el.getBoundingClientRect().top < barH();
      el.style.opacity = hide ? '0' : '1';
      el.style.pointerEvents = hide ? 'none' : 'auto';
    }
    function applyAll() { Array.prototype.forEach.call(tops, apply); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { apply(e.target); });
      }, { root: null, rootMargin: '-' + Math.round(barH()) + 'px 0px 0px 0px', threshold: [0, 1] });
      Array.prototype.forEach.call(tops, function (el) { io.observe(el); });
    }
    $(window).on('scroll.bundleTop resize.bundleTop', function () { window.requestAnimationFrame(applyAll); });
    applyAll();
  })();
  // -------------------------------------------------------------------------

  // Bundle: keep --bb-sticky-bar-height in sync with the live height of the
  // sticky search row, so the collection-group headers tuck under it cleanly
  // even when its content/padding/border change. Falls back to the CSS value
  // (set in custom.css) if the bar isn't on the page.
  (function syncBundleStickyBarHeight() {
    var bundle = document.getElementById('create-your-bundle');
    if (!bundle) return;
    var bar = bundle.querySelector('.cst_bndl_search_mn');
    if (!bar) return;
    function update() {
      // +11 = bar's `top: 12px` offset minus 1px so the bar/header borders overlap.
      bundle.style.setProperty('--bb-sticky-bar-height', (bar.offsetHeight + 11) + 'px');
    }
    update();
    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(bar);
    } else {
      $(window).on('resize', update);
    }
  })();

  // =========================================================================
  // BUNDLE UX FEATURES (June 2026). Each is gated by a flag below. To turn ANY
  // single feature off, set its flag to false and re-push — instant rollback,
  // nothing else is affected.
  // =========================================================================
  var BB_FEATURES = {
    collectionScroller: true, // color chips that replace the "All Collections" dropdown
    collectionTabs:     false, // OFF = chips jump-scroll to a collection + a scroll-spy highlights the current one as you scroll (no floating header). ON = filter-tabs + "Show All".
    firstStepHint:      false, // one-line "how to start" at the top of the picker (OFF for now, per Zack — flip to true to restore)
    biggerTapTargets:   true, // larger +/- and Add buttons on phones
    stickyMobileBar:    true, // count + Add-to-Cart bar pinned to the bottom on phones
    brandAccent:        false, // brand-mint accents OFF (reverted per Zack); flip true to re-add. Active-chip ring uses the duller teal in custom.css instead.
    // 3-across mobile: ROLLED OUT TO EVERYONE 2026-07-21 — IntelliGems retest (Jul 12-21, mobile-only,
    // 24.5k visitors) showed +30% conversion / +33% revenue-per-visitor at 97-99% confidence and Zack
    // called it. During the test this was keyed AT RUNTIME off Shopify.theme.id === 189599875386 — if a
    // new grid test ever runs, key it off the theme id again, NEVER a per-theme constant (a constant got
    // clobbered by shared pushes once → both arms served 2-across; Zack caught it 2026-07-12).
    threeAcrossMobile:  true,
    // Desktop 4-across is LIVE for everyone (Zack 2026-07-12: "can't imagine 4 isn't better" — promoted from
    // the test arm). On the test theme it's superseded by 5-across below (only ONE of the two classes is
    // ever applied, so the grids never fight).
    fourAcrossDesktop:  true,
    // Desktop 5-across (vs live's 4) = the NEW desktop A/B variant, runtime theme-id keyed like 3-across.
    fiveAcrossDesktop:  !!(window.Shopify && Shopify.theme && Shopify.theme.id === 189599875386),
    heroBanner:         false  // placeholder hero OFF for now (per Zack); flip true to bring back the video/image section.
  };
  (function () {
    var b = document.body;
    // Collection header vs "Add all" button balance — switch to preview each: 'lead' | 'differentiate' | 'trim'.
    var HEADER_STYLE = 'trim';
    b.classList.add('hdr-' + HEADER_STYLE);
    // Per-character Collect + stepper placement — 'classic' (the EXACT current snapshot) | 'corner' (test: in
    // the image's top-right corner, shrunk). 'classic' adds no corner CSS, so it restores today's look exactly.
    var COLLECT_STYLE = 'classic';
    b.classList.add('collect-' + COLLECT_STYLE);
    // Card grouping — make each Collect button clearly belong to ITS character. Switch to preview each:
    // 'tile' (whole card in one boxed tile) | 'tight' (button hugs its character + clear gap to the next) |
    // 'panel' (name + button sit on a connected card directly under the image).
    var GROUP_STYLE = 'tile';
    b.classList.add('grp-' + GROUP_STYLE);
    if (BB_FEATURES.collectionScroller) b.classList.add('bbf-scroller');
    if (BB_FEATURES.biggerTapTargets)   b.classList.add('bbf-taptargets');
    if (BB_FEATURES.stickyMobileBar)    b.classList.add('bbf-stickybar');
    if (BB_FEATURES.brandAccent)        b.classList.add('bbf-brandaccent');
    if (BB_FEATURES.threeAcrossMobile)  b.classList.add('bbf-3across');
    if (BB_FEATURES.fourAcrossDesktop && !BB_FEATURES.fiveAcrossDesktop) b.classList.add('bbf-4across');
    if (BB_FEATURES.fiveAcrossDesktop)  b.classList.add('bbf-5across');
  })();

  // ---- Feature: collection chip scroller (replaces the dropdown) ----
  if (BB_FEATURES.collectionScroller) {
    (function () {
      var root = document.getElementById('create-your-bundle');
      if (!root) return;
      var searchBar = root.querySelector('.cst_bndl_search_mn');
      var groups = root.querySelectorAll('.bundle-collection-group');
      if (!searchBar || !groups.length) return;
      // Chip colors come from each group's --series-main / --series-text (set by
      // custom-bundle-product.liquid from the collection metaobject, 2026-09-24) — the
      // hardcoded tints map is gone, so a new series gets a colored chip for free.
      var bar = document.createElement('div'); bar.className = 'bb-chipbar';
      var track = document.createElement('div'); track.className = 'bb-chiptrack';
      // Tabs mode: chips FILTER to one collection at a time; a "Show All" chip restores the full stack.
      function setFilter(slug) {
        groups.forEach(function (gr) {
          var s = gr.getAttribute('data-collection');
          gr.classList.toggle('bb-tabhide', !(slug === 'all' || s === slug));
        });
        track.querySelectorAll('.bb-chip').forEach(function (c) {
          c.classList.toggle('is-active', c.getAttribute('data-target') === slug);
        });
        // If we're scrolled down into the list, bring the chosen collection's top up under
        // the bar so you don't land mid-collection. Crucially we only ever scroll UP —
        // never down from the top (that downward snap is the thing Zack didn't want).
        if (slug !== 'all') {
          var grp = root.querySelector('.bundle-collection-group[data-collection="' + slug + '"]');
          if (grp) {
            var off = (parseFloat(getComputedStyle(root).getPropertyValue('--bb-sticky-bar-height')) || 80) + 18;
            var y = Math.max(0, grp.getBoundingClientRect().top + (window.pageYOffset || 0) - off);
            if ((window.pageYOffset || 0) > y + 1) { window.scrollTo(0, y); }
          }
        }
      }
      // Build the chip carousel: an "All" chip + one per collection, rendered 3x so the active
      // chip can always center with neighbors on both sides (a soft loop on mobile).
      function bbOffset() {
        var st = parseFloat(getComputedStyle(searchBar).top); if (isNaN(st)) st = 0;
        return (searchBar.getBoundingClientRect().height || 80) + st; // land exactly at the bar's bottom (no previous-collection sliver above)
      }
      function bbJumpTo(slug) {
        if (slug === 'all') { window.scrollTo(0, 0); return; }
        var g = root.querySelector('.bundle-collection-group[data-collection="' + slug + '"]');
        if (!g) return;
        // Always go to the collection. If the bar isn't pinned to the top yet (you're still up near the
        // top), GLIDE there with a smooth scroll instead of an abrupt snap; once pinned, jump instantly.
        var st = parseFloat(getComputedStyle(searchBar).top); if (isNaN(st)) st = 0;
        var pinned = searchBar.getBoundingClientRect().top <= st + 4;
        var y = Math.max(0, g.getBoundingClientRect().top + (window.pageYOffset || 0) - bbOffset());
        window.scrollTo({ top: y, behavior: pinned ? 'auto' : 'smooth' });
      }
      var chipDefs = [{ slug: 'all', name: 'All', bg: '#14b8a6', fg: '#fff' }];
      groups.forEach(function (g) {
        var slug = g.getAttribute('data-collection');
        var t = g.querySelector('.bundle-collection-header__title');
        var nm = (t ? t.textContent : slug).replace(/\s*Collection\s*$/i, '').trim();
        var gcs = getComputedStyle(g);
        chipDefs.push({
          slug: slug, name: nm,
          bg: gcs.getPropertyValue('--series-main').trim() || null,
          fg: gcs.getPropertyValue('--series-text').trim() || null,
          special: g.getAttribute('data-special-style'),
          textMode: g.getAttribute('data-series-text')
        });
      });
      var CHIP_COPIES = 1, CHIP_MID = 0; // single set (no infinite loop): "All" on the far left, a definitive far right
      for (var cc = 0; cc < CHIP_COPIES; cc++) {
        chipDefs.forEach(function (def) {
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'bb-chip' + (def.slug === 'all' ? ' bb-chip--all' : '');
          chip.setAttribute('data-target', def.slug);
          chip.setAttribute('data-copy', cc);
          if (def.special) { chip.setAttribute('data-special-style', def.special); }
          if (def.textMode) { chip.setAttribute('data-series-text', def.textMode); }
          // Long names stack to TWO lines, e.g. "Stars &" over "Stripes" (Davis 2026-08-18,
          // revised same day from 3 lines: the tall version towered over the short mobile chips).
          // Generalized 2026-09-24: any name of 3+ words breaks before its last word. Word
          // count, not length: "Kids' Monsters" (14 chars) stays one line, "Stars & Stripes"
          // (15) stacks. Text nodes, not innerHTML: the name comes from admin.
          var words = def.name.split(/\s+/);
          if (def.slug !== 'all' && words.length >= 3) {
            chip.classList.add('bb-chip--stacked');
            chip.appendChild(document.createTextNode(words.slice(0, -1).join(' ')));
            chip.appendChild(document.createElement('br'));
            chip.appendChild(document.createTextNode(words[words.length - 1]));
          } else { chip.textContent = def.name; }
          if (def.bg) { chip.style.background = def.bg; chip.style.color = def.fg; }
          chip.addEventListener('click', function () {
            var slug = this.getAttribute('data-target');
            if (BB_FEATURES.collectionTabs && slug !== 'all') { setFilter(slug); return; }
            bbJumpTo(slug);
          });
          track.appendChild(chip);
        });
      }
      bar.appendChild(track);
      // Move the existing search INTO the same row — it stays collapsed (width 0) until
      // the magnifier is tapped, so the bar is always exactly one row tall.
      var searchInpt = root.querySelector('.cst_bndl_search_mn .searc_bar_inpt');
      if (searchInpt) { bar.appendChild(searchInpt); }
      // Magnifier: kept in the row for DESKTOP; on mobile it's hidden and the trigger lives in the
      // bottom bar instead (frees the chip row). A single shared toggle drives both.
      var magSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><line x1="16.5" y1="16.5" x2="21" y2="21"></line></svg>';
      var xSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>';
      var searchInput = bar.querySelector('#B_open-search-bar') || root.querySelector('#B_open-search-bar');
      var searchBtn = document.createElement('button');
      searchBtn.type = 'button'; searchBtn.className = 'bb-searchbtn';
      searchBtn.setAttribute('aria-label', 'Search characters');
      searchBtn.innerHTML = magSvg;
      // Single source of truth: toggle character search, focus/reset the input, sync the icon. Returns the new state.
      window.bbToggleSearch = function () {
        var on = searchBar.classList.toggle('bb-searchmode');
        var input = root.querySelector('#B_open-search-bar') || searchInput;
        if (on) {
          if (input) { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } } // synchronous so iOS opens the keyboard
        } else {
          root.classList.remove('bb-searching');
          if (input) {
            input.value = '';
            if (window.jQuery) { window.jQuery(input).trigger('keyup'); }
            else { input.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true })); }
            input.blur();
          }
        }
        searchBtn.innerHTML = on ? xSvg : magSvg;
        searchBtn.setAttribute('aria-label', on ? 'Close search' : 'Search characters');
        return on;
      };
      searchBtn.addEventListener('click', function () { window.bbToggleSearch(); });
      bar.appendChild(searchBtn);
      searchBar.appendChild(bar);
      // Replace the old "All Collections" dropdown (inline !important so it always wins).
      var oldDropdown = root.querySelector('.searc_bar_filter');
      if (oldDropdown) { oldDropdown.style.setProperty('display', 'none', 'important'); }
      // Side-to-side scroll indicator UNDERNEATH the chips (instead of blurring the edges).
      var hint = document.createElement('div');
      hint.className = 'bb-scrollhint'; hint.setAttribute('aria-hidden', 'true');
      hint.innerHTML =
        '<svg class="bb-scrollhint__ar bb-scrollhint__ar--l" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="14 6 8 12 14 18"></polyline></svg>' +
        '<span class="bb-scrollhint__label">Swipe for more</span>' +
        '<svg class="bb-scrollhint__ar bb-scrollhint__ar--r" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="10 6 16 12 10 18"></polyline></svg>';
      // "Swipe for more" hint sits in a centered flex band (search is now a pill in the chip row).
      var foot = document.createElement('div');
      foot.className = 'bb-chip-foot';
      foot.appendChild(hint);
      searchBar.appendChild(foot);
      // Search as the first PILL in the scrolling track (Zack): looks like a collection chip (solid) and
      // scrolls left/right with them. Tapping it opens the search bar (same as the old magnifier). In search
      // mode the track collapses, so closing is handled by the X button (.bb-searchbtn, shown only then).
      var searchChip = document.createElement('button');
      searchChip.type = 'button';
      searchChip.className = 'bb-chip bb-chip--search';
      searchChip.setAttribute('aria-label', 'Search characters');
      searchChip.innerHTML = magSvg + '<span class="bb-chip--search-t">Search</span>';
      searchChip.addEventListener('click', function () { if (window.bbToggleSearch) { window.bbToggleSearch(); } });
      track.insertBefore(searchChip, track.firstChild);
      function bbSyncBar() {
        root.style.setProperty('--bb-sticky-bar-height', (searchBar.offsetHeight + 11) + 'px');
      }
      bbSyncBar();
      if (window.requestAnimationFrame) { requestAnimationFrame(bbSyncBar); }
      setTimeout(bbSyncBar, 250);
      window.addEventListener('resize', bbSyncBar);
      // Scroll-spy (jump mode): the floating collection header is gone, so the chip bar IS the
      // "where am I" indicator. Highlight exactly ONE chip — the collection crossing ~38% of the
      // screen — keep it scrolled into view in the strip, and never touch the page's own scroll.
      if (!BB_FEATURES.collectionTabs) {
        (function () {
          var midChips = track.querySelectorAll('.bb-chip[data-copy="' + CHIP_MID + '"]'); // canonical copy = centering reference
          var allChips = track.querySelectorAll('.bb-chip');
          var groupList = []; groups.forEach(function (g) { groupList.push(g); });
          if (!allChips.length || !groupList.length) return;
          var current = null, ticking = false, userTouching = false, releaseT = null, safetyT = null, blockW = 0;
          // hold/release track whether the USER is swiping the strip (so we never fight them). A safety
          // timer guarantees userTouching can't get stuck on (e.g. a dropped/cancelled touch).
          function hold() { userTouching = true; if (releaseT) { clearTimeout(releaseT); releaseT = null; } if (safetyT) clearTimeout(safetyT); safetyT = setTimeout(function () { userTouching = false; }, 1500); }
          function release() { if (releaseT) clearTimeout(releaseT); releaseT = setTimeout(function () { userTouching = false; }, 700); }
          track.addEventListener('touchstart', hold, { passive: true });
          track.addEventListener('pointerdown', hold, { passive: true });
          track.addEventListener('touchend', release, { passive: true });
          track.addEventListener('pointerup', release, { passive: true });
          track.addEventListener('touchcancel', release, { passive: true });
          track.addEventListener('pointercancel', release, { passive: true });
          // Swiping the WHOLE chip section (the row + the "swipe for more" zone underneath) uses the chips'
          // OWN native horizontal scroll — no custom JS momentum (that felt jolty). The CSS makes the track
          // physically taller (padding-bottom) so its touch area extends down past the chips, and the hint is
          // an overlay with pointer-events:none, so a drag anywhere in the section scrolls the track natively.
          // Center the canonical (middle) copy of the active chip — horizontal only, never the page.
          // Uses getBoundingClientRect (robust vs offsetParent). No-ops when the strip doesn't overflow (desktop).
          function centerMid(slug, instant) {
            if (track.scrollWidth <= track.clientWidth + 4) return;
            if (userTouching && !instant) return;
            var chip = null;
            midChips.forEach(function (c) { if (c.getAttribute('data-target') === slug) chip = c; });
            if (!chip) return;
            var rel = chip.getBoundingClientRect().left - track.getBoundingClientRect().left;
            var target = Math.max(0, track.scrollLeft + rel - (track.clientWidth - chip.offsetWidth) / 2);
            if (instant) { track.scrollLeft = target; } else { track.scrollTo({ left: target, behavior: 'smooth' }); }
          }
          // Which collection are we looking at? "all" above the first; the one crossing ~38%; last at the bottom.
          function activeSlug() {
            var doc = document.documentElement;
            if ((window.innerHeight + (window.pageYOffset || window.scrollY)) >= ((doc.scrollHeight || document.body.scrollHeight) - 4))
              return groupList[groupList.length - 1].getAttribute('data-collection');
            var ref = window.innerHeight * 0.38;
            if (groupList[0].getBoundingClientRect().top > ref) return 'all';
            var win = null;
            for (var i = 0; i < groupList.length; i++) {
              var r = groupList[i].getBoundingClientRect();
              if (r.top <= ref && r.bottom > ref) { win = groupList[i]; break; } // straddles the line
              if (r.top <= ref) { win = groupList[i]; } // fallback: topmost above the line
            }
            return win ? win.getAttribute('data-collection') : 'all';
          }
          function pick() {
            ticking = false;
            var slug = activeSlug();
            if (slug === current) return;
            current = slug;
            allChips.forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-target') === slug); }); // all 3 copies
            centerMid(slug);
          }
          function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(pick); } }
          window.addEventListener('scroll', onScroll, { passive: true });
          window.addEventListener('resize', onScroll);
          // Seed: highlight + instantly center on load (after layout settles so offsets are real).
          function seed() { current = null; pick(); centerMid(current, true); }
          setTimeout(seed, 350);
          // Re-center once the web font finishes loading (it can change chip widths after the seed).
          if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function () { centerMid(current, true); }); }
        })();
      }
      // Tabs mode: default to the first collection. (Search spanning all collections is
      // handled in the jQuery keyup filter below, which toggles the .bb-searching class.)
      if (BB_FEATURES.collectionTabs) {
        setFilter('all'); // default view = "Show All" (per Zack), not the first collection
      }
    })();
  }

  // Tapping a collection's header jumps to the top of that collection (skip-to-top button).
  $(document).on('click', '#create-your-bundle .bundle-collection-header', function () {
    var grp = $(this).closest('.bundle-collection-group')[0];
    if (!grp) return;
    var rootEl = document.getElementById('create-your-bundle');
    var sbEl = rootEl.querySelector('.cst_bndl_search_mn');
    var st = sbEl ? parseFloat(getComputedStyle(sbEl).top) : 0; if (isNaN(st)) st = 0;
    var off = sbEl ? (sbEl.getBoundingClientRect().height + st) : 80; // land exactly at the bar's bottom
    var y = grp.getBoundingClientRect().top + (window.pageYOffset || 0) - off;
    window.scrollTo(0, Math.max(0, y));
  });

  // (The old shrink-header-on-scroll driver was removed — the collection header is now a plain,
  // non-floating title that scrolls away; the sticky chip bar highlights the current collection.)

  // ---- Feature: first-step hint at the top of the picker ----
  if (BB_FEATURES.firstStepHint) {
    (function () {
      var root = document.getElementById('create-your-bundle');
      if (!root) return;
      var searchBar = root.querySelector('.cst_bndl_search_mn');
      if (!searchBar || root.querySelector('.bb-firststep')) return;
      var hint = document.createElement('p');
      hint.className = 'bb-firststep';
      hint.innerHTML = 'Pick a size above, then tap your favorites — or hit <b>Mystery Fill</b> for a surprise.';
      searchBar.parentNode.insertBefore(hint, searchBar);
    })();
  }

  // ---- Feature: hero banner placeholder at the top (swap for a real video/image later) ----
  if (BB_FEATURES.heroBanner) {
    (function () {
      var root = document.getElementById('create-your-bundle');
      if (!root) return;
      var titleArea = root.querySelector('.product-detail__title-area');
      if (!titleArea || root.querySelector('.bb-hero')) return;
      var hero = document.createElement('div');
      hero.className = 'bb-hero';
      // NOTE: placeholder. To use a real asset later, replace the innerHTML below with a
      // <video> or <img> (see report). Images pulled from existing product art.
      hero.innerHTML =
        '<div class="bb-hero__toys">' +
          '<img src="https://wigglitz.com/cdn/shop/files/strstrp_Wizard_Archie_300x.png?v=1772686612" alt="" loading="lazy">' +
          '<img src="https://wigglitz.com/cdn/shop/files/strstrp_AbrahamLincoln_Abraham_BE_300x.png?v=1772663383" alt="" loading="lazy">' +
        '</div>' +
        '<h2 class="bb-hero__title">Build Your Bundle Today!</h2>' +
        '<div class="bb-hero__ribbon">Pick your bundle size, then choose your favorite Wigglitz!</div>' +
        '<span class="bb-hero__tag">Placeholder — your video / image goes here</span>';
      titleArea.parentNode.insertBefore(hero, titleArea);
    })();
  }

  // ---- Feature: sticky "your bundle" bar on phones ----
  if (BB_FEATURES.stickyMobileBar) {
    (function () {
      var root = document.getElementById('create-your-bundle');
      if (!root) return;
      var bar = document.createElement('div');
      bar.id = 'bb-stickybar';
      // Open-drawer cue style — switch this to preview each: 'tab' | 'handle' | 'notch'.
      var PEEK_STYLE = 'notch';
      bar.innerHTML =
        '<button type="button" class="bb-sb-peek" aria-label="Open your bundle"><svg class="bb-sb-peek-ar" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 15 12 9 18 15"></polyline></svg><span class="bb-sb-peek-lbl">View bundle</span></button>' +
        '<div class="bb-sb-toggle" role="button" tabindex="0" aria-label="Show your bundle">' +
          '<span class="bb-sb-meter">' +
            '<span class="bb-sb-track"><span class="bb-sb-prog-fill"></span></span>' +
            '<span class="bb-sb-dot" style="left:14%"><i></i><b>6</b></span>' +
            '<span class="bb-sb-dot" style="left:34%"><i></i><b>15</b></span>' +
            '<span class="bb-sb-dot" style="left:64%"><i></i><b>30</b></span>' +   // labels re-synced from bbTiers() in update()
            '<span class="bb-sb-dot bb-sb-dot--end" style="left:100%"><i></i><b>50+</b></span>' +
          '</span>' +
          '<span class="bb-sb-line2">' +
            '<span class="bb-sb-nudge"></span>' +
          '</span>' +
        '</div>' +
        '<div class="bb-sb-actions">' +
          '<button type="button" class="bb-sb-mystery"><svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M10 3.5 L11.5 8 L16 9.5 L11.5 11 L10 15.5 L8.5 11 L4 9.5 L8.5 8 Z"></path><path d="M17.5 12.5 L18.3 14.4 L20 15 L18.3 15.6 L17.5 17.5 L16.7 15.6 L15 15 L16.7 14.4 Z"></path></svg>Mystery Fill</button>' +
          '<button type="button" class="bb-sb-btn">Add to Cart</button>' +
        '</div>';
      document.body.appendChild(bar);
      bar.classList.add('peek-' + PEEK_STYLE);
      var btn = bar.querySelector('.bb-sb-btn');
      var mysteryBtn = bar.querySelector('.bb-sb-mystery');
      var toggleBtn = bar.querySelector('.bb-sb-toggle');
      var fillEl = bar.querySelector('.bb-sb-prog-fill');
      var nudgeEl = bar.querySelector('.bb-sb-nudge');
      var dotEls = toggleBtn.querySelectorAll('.bb-sb-dot');
      // Mobile nudge auto-size (Zack): ONE size for ALL tiers — the biggest font that fits the
      // longest (36->50) message on TWO rows. Applied to every stage so the text is uniformly big.
      // Fit to the live nudge width, cached, re-fit on rotation/resize. No-op on desktop (bar
      // hidden → width 0, keeps the stylesheet size).
      var bbNudgeSz = { px: 0, w: -1 };
      function bbFitNudge() {
        var w = nudgeEl.clientWidth;
        if (w && w !== bbNudgeSz.w) {
          bbNudgeSz.w = w;
          var probe = document.createElement('span');
          var cs = getComputedStyle(nudgeEl);
          probe.style.cssText = 'position:absolute;visibility:hidden;left:-9999px;top:0;width:' + w + 'px;font-family:' + cs.fontFamily + ';font-weight:800;line-height:1.25;';
          probe.textContent = 'Add 33 more to get 51% off, TWO guaranteed SHINY Wigglitz plus FREE SHIPPING'; // longest 32->65 msg
          document.body.appendChild(probe);
          var s = 24; for (; s > 12; s--) { probe.style.fontSize = s + 'px'; if (probe.scrollHeight <= s * 1.25 * 2 + 1) break; }
          document.body.removeChild(probe);
          bbNudgeSz.px = s;
        }
        if (bbNudgeSz.px) { nudgeEl.style.fontSize = bbNudgeSz.px + 'px'; }
      }
      // In-drawer progress bar (mobile): the "fullest" copy of this meter, shown at the TOP of the drawer when
      // it's open — replacing the old "Please select…" heading + dot track. Same data as the sticky meter, but
      // bigger and with the 0 milestone, a status line, and a Mystery Fill guidance line. Hidden on desktop +
      // when closed (it lives inside the drawer, which only shows when open).
      var dwFill = null, dwDotEls = [], dwMsg = null, dwGuide = null, lastDwCount = -1;
      var bundleText = root.querySelector('.cstm-bundle-content .cstm-bundle-text');
      if (bundleText) {
        var dw = document.createElement('div');
        dw.className = 'bb-dwbar';
        dw.innerHTML =
          '<div class="bb-dwbar-meter">' +
            '<span class="bb-dwbar-track"><span class="bb-dwbar-fill"></span></span>' +
            '<span class="bb-dwbar-dot bb-dwbar-dot--start" style="left:0%"><b>0</b></span>' +
            '<span class="bb-dwbar-dot" style="left:14%"><b>6</b></span>' +
            '<span class="bb-dwbar-dot" style="left:34%"><b>15</b></span>' +
            '<span class="bb-dwbar-dot" style="left:64%"><b>30</b></span>' +
            '<span class="bb-dwbar-dot bb-dwbar-dot--end" style="left:100%"><b>50+</b></span>' +
          '</div>' +
          '<div class="bb-dwbar-msg"></div>' +
          '<div class="bb-dwbar-guide">…or hit <b>Mystery Fill</b> to make the rest a surprise</div>';
        bundleText.insertBefore(dw, bundleText.firstChild);
        dwFill = dw.querySelector('.bb-dwbar-fill');
        dwDotEls = dw.querySelectorAll('.bb-dwbar-dot');
        dwMsg = dw.querySelector('.bb-dwbar-msg');
        dwGuide = dw.querySelector('.bb-dwbar-guide');
      }
      // Tapping a NOT-READY Add to Cart explains WHY instead of silently doing
      // nothing (Zack): a quick toast — "Add X more … or remove Y / switch smaller".
      var toastTimer = null;
      function bbToast(text) {
        var t = document.getElementById('bb-atc-toast');
        if (!t) {
          t = document.createElement('div');
          t.id = 'bb-atc-toast';
          document.body.appendChild(t);
        }
        t.textContent = text;
        t.classList.add('is-on');
        if (toastTimer) { clearTimeout(toastTimer); }
        toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
      }
      btn.addEventListener('click', function () {
        if (btn.classList.contains('bb-sb-btn--off')) {
          // Grayed = the count isn't on a full size yet. Toast the SAME guidance the desktop
          // helper shows (shared bbGoalMsg), then bail.
          var c = (typeof bundleCurrentCount === 'function') ? bundleCurrentCount() : 0;
          bbToast(bbGoalMsg(c, 'button'));
          return;
        }
        bbCheckoutReached();   // reached a full size → add at that size (money-safe, shared with desktop)
      });
      mysteryBtn.addEventListener('click', function () {
        var r = document.querySelector('#create-your-bundle .random-button');
        if (r) { r.click(); }
      });
      toggleBtn.addEventListener('click', function () {
        // Opens even when empty so shoppers discover the drawer + see the "will appear here" note (Zack).
        var a = document.querySelector('#create-your-bundle .mobile_sc_arrow');
        if (a) { a.click(); setTimeout(update, 320); } // re-pad the drawer once the button-grow settles
      });
      var peekBtn = bar.querySelector('.bb-sb-peek');
      if (peekBtn) {
        peekBtn.addEventListener('click', function () {
          var a = document.querySelector('#create-your-bundle .mobile_sc_arrow');
          if (a) { a.click(); setTimeout(update, 320); } // opens; delayed re-pad after the button-grow settles
        });
      }
      // Search trigger lives here on mobile (frees the chip row up top); drives the shared toggle.
      var searchSb = bar.querySelector('.bb-sb-search');
      var sbMag = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><line x1="16.5" y1="16.5" x2="21" y2="21"></line></svg>';
      var sbX = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>';
      if (searchSb) {
        searchSb.addEventListener('click', function (e) {
          e.stopPropagation(); // search lives inside the toggle now — don't also open the drawer
          var on = window.bbToggleSearch ? window.bbToggleSearch() : false;
          searchSb.innerHTML = on ? sbX : sbMag;
          searchSb.setAttribute('aria-label', on ? 'Close search' : 'Search characters');
          searchSb.classList.toggle('is-on', on);
        });
      }
      function update() {
        var main = document.querySelector('.custom-add-to_cart');
        var count = (typeof bundleCurrentCount === 'function') ? bundleCurrentCount() : 0;
        // Count-based readiness (shared with desktop): enabled at any full size (6/15/36/50+),
        // even below a tapped size. (Was gated on .custom-add-to_cart's ceiling-based class.)
        var tbtn = bbTierBtn(count);
        var ready = tbtn.ready;
        var sb = document.querySelector('#create-your-bundle .cstm-bundle-content');
        var open = !!(sb && sb.classList.contains('open-popupBar'));
        // Empty-drawer note: inject a friendly placeholder next to the (empty) character list once, then
        // flag the drawer empty/not so CSS shows it only while the bundle is empty (mobile only, Zack).
        if (sb) {
          var bbListSec = sb.querySelector('.bundle_cart_main_sec');
          // The note lives INSIDE the list box so the empty drawer is exactly as tall as a filled one
          // (the list's own open height applies either way — verified at 390px). Cart re-renders wipe
          // the list's HTML, so re-add the note whenever it's missing while the bundle is empty.
          if (bbListSec && count < 1 && !bbListSec.querySelector('.bb-empty-note')) {
            var bbNote = document.createElement('div');
            bbNote.className = 'bb-empty-note';
            bbNote.textContent = 'When you add your Wigglitz to the bundle, they’ll appear here.';
            bbListSec.appendChild(bbNote);
          }
          sb.classList.toggle('bb-drawer-empty', count < 1);
        }
        if (count < 1) {
          // Empty: just an invitation, no progress bar. (No count number — the bar does the work.)
          nudgeEl.textContent = 'Start adding Wigglitz!';
          bbFitNudge();
          toggleBtn.classList.add('bb-sb-empty');
          toggleBtn.setAttribute('aria-label', 'Start adding Wigglitz');
          // Reset the in-drawer bar too (e.g. if Remove All is hit while the drawer is open) so it doesn't
          // show stale progress over an empty bundle. Guarded on count to avoid looping the observer.
          if (dwFill && count !== lastDwCount) {
            lastDwCount = count;
            dwFill.style.width = '2%';
            for (var dze = 0; dze < dwDotEls.length; dze++) { dwDotEls[dze].classList.remove('is-done', 'is-target'); }
            if (dwMsg) { dwMsg.innerHTML = 'Start adding Wigglitz!'; }
          }
        } else {
          toggleBtn.classList.remove('bb-sb-empty');
          // Sizes are price breaks (quantities read live from the Size variants — see bbTiers()).
          // Bubbles sit at 14/34/64/100% — the early tiers are squeezed left so the later stretches
          // (where people keep collecting) get more room. Within EACH range the step is perfectly even
          // (linear interpolation, NO integer rounding — that rounding was what made some single adds
          // jump 2% and others 1%).
          var tiers = bbTiers();
          var tierN = [tiers[0].q, tiers[1].q, tiers[2].q, tiers[3].q];
          // per-each price per tier, for the "save X%" nudges (ratio, so currency-agnostic)
          var ea = [];
          for (var ei = 0; ei < tiers.length; ei++) { ea.push(tiers[ei].price > 0 ? tiers[ei].price / tiers[ei].q : 0); }
          // keep the bubble labels in sync with the live variants (e.g. 30 -> 36 after a rename)
          for (var bl = 0; bl < dotEls.length && bl < 4; bl++) {
            var lb = dotEls[bl].querySelector('b');
            // Last dot counts UP past 50 (Zack): 51, 52 … instead of a static "50+".
            var want = (bl === 3) ? (count > tierN[3] ? String(count) : (tierN[3] + '+')) : String(tierN[bl]);
            if (lb && lb.textContent !== want) { lb.textContent = want; }
          }
          // Adaptive "dynamic focus" layout (Zack) — now on BOTH mobile bars AND desktop (was
          // desktop-only): the stretch you're currently filling takes the lion's share of the bar;
          // finished stretches compress to 16% each, upcoming ones stay a compact 19%. The fill +
          // dots glide (CSS transitions) so it reads as one smooth zoom, never a jump.
          var dwVals = [0, tierN[0], tierN[1], tierN[2], tierN[3]];
          var seg = 3;
          if (count < dwVals[1]) { seg = 0; }
          else if (count < dwVals[2]) { seg = 1; }
          else if (count < dwVals[3]) { seg = 2; }
          var wts = [], others = 0;
          for (var wi = 0; wi < 4; wi++) { wts[wi] = (wi < seg) ? 16 : (wi > seg ? 19 : 0); others += wts[wi]; }
          wts[seg] = 100 - others;
          var dwPos = [0];
          for (wi = 0; wi < 4; wi++) { dwPos.push(dwPos[wi] + wts[wi]); }
          var dwPct;
          if (count >= dwVals[4]) { dwPct = 100; }
          else { var sa = dwVals[seg], sb = dwVals[seg + 1]; dwPct = Math.max(2, dwPos[seg] + ((count - sa) / (sb - sa)) * wts[seg]); }
          // Sticky-bar meter (always visible, bottom): adaptive fill + glide the 4 milestone dots.
          if (fillEl) { fillEl.style.width = dwPct.toFixed(2) + '%'; }
          for (var sdi = 0; sdi < dotEls.length; sdi++) { dotEls[sdi].style.left = dwPos[sdi + 1] + '%'; }
          // Dot states: done (reached), target (next goal), or upcoming.
          var targetIdx = -1;
          for (var t = 0; t < tierN.length; t++) { if (count < tierN[t]) { targetIdx = t; break; } }
          for (var di = 0; di < dotEls.length; di++) {
            dotEls[di].classList.toggle('is-done', count >= tierN[di]);
            dotEls[di].classList.toggle('is-target', di === targetIdx);
          }
          // Status message (Zack's table). Below tier 1: reach the minimum. Toward tiers 2-3: "save X%"
          // toward the next price tier — unless the % rounds to ~nothing (the free-shipping tier under the
          // .99 pricing), then sell FREE SHIPPING instead. Toward 50+: the shiny + shipping reward. 50+: celebration.
          // Copy comes from the SHARED bbGoalMsg() (defined near reconcile) so this top
          // heading and the bottom desktop Add-to-Cart helper always say the same thing.
          var msg = bbGoalMsg(count, 'top');
          if (nudgeEl) {
            // 15->36: drop "FREE SHIPPING" to its own centered 2nd line so the rest can go big on line 1.
            var html = (targetIdx === 2) ? msg.replace(/\s*FREE SHIPPING\s*$/i, '<span class="bb-sb-nl">FREE SHIPPING</span>') : msg;
            nudgeEl.innerHTML = html;
            toggleBtn.classList.add('bb-sb-bigmsg');                      // hide the count number → the big nudge owns the width
            bbFitNudge();                                                 // one uniform size for every tier (Zack)
          }
          // Mirror the SAME adaptive layout into the in-drawer bar. Only when count changes — this
          // writes INSIDE the observed drawer, so the count guard stops the MutationObserver looping.
          if (dwFill && count !== lastDwCount) {
            lastDwCount = count;
            dwFill.style.width = dwPct.toFixed(2) + '%';
            var dwTarget = (targetIdx >= 0) ? tierN[targetIdx] : -1;
            for (var dwi = 0; dwi < dwDotEls.length; dwi++) {
              dwDotEls[dwi].style.left = dwPos[dwi] + '%';
              dwDotEls[dwi].classList.toggle('is-done', count >= dwVals[dwi]);
              dwDotEls[dwi].classList.toggle('is-target', dwVals[dwi] === dwTarget);
              var dlb = dwDotEls[dwi].querySelector('b');
              // Last dot counts UP past 50 (Zack): 51, 52 … instead of a static "50+".
              var dwant = (dwi === 4) ? (count > dwVals[4] ? String(count) : (dwVals[4] + '+')) : String(dwVals[dwi]);
              if (dlb && dlb.textContent !== dwant) { dlb.textContent = dwant; }
            }
            if (dwMsg && typeof msg !== 'undefined') { dwMsg.innerHTML = msg; }
            // Hide the "or hit Mystery Fill" guide once they're at the top tier (50+) — there's no "rest" left.
            if (dwGuide) { dwGuide.style.display = (count >= tierN[3]) ? 'none' : ''; }
          }
          toggleBtn.setAttribute('aria-label', (open ? 'Hide' : 'View') + ' your bundle, ' + count + ' added');
        }
        btn.textContent = (ready && tbtn.price) ? ('Add to Cart · ' + tbtn.price) : 'Add to Cart';
        btn.classList.toggle('bb-sb-btn--off', !ready);
        bar.classList.toggle('bb-sb-open', open);
        bar.classList.toggle('bb-sb-noitems', count < 1); // hide the peek cue when there's nothing to open
        // Reserve EXACTLY the bar's height so the character grid is never hidden — and so it only grows
        // when the long messages wrap (30-49 / 50+), staying tight otherwise. Mobile only (bar is hidden
        // on desktop → height 0 → fall back to the stylesheet).
        if (bar.offsetHeight > 0) {
          root.style.setProperty('padding-bottom', (bar.offsetHeight + 4) + 'px', 'important');
        } else {
          root.style.removeProperty('padding-bottom');
        }
        // Open drawer: pad its bottom to just clear the (now buttons-only) bar + a small tasteful gap, so
        // there's no big empty void under Remove All. Adapts to the actual bar height (the bigger open-state
        // buttons + the device safe-area). A delayed re-run (in the open handlers) catches the settled height
        // after the button grow transition.
        if (open && sb && bar.offsetHeight > 0) {
          sb.style.setProperty('padding-bottom', (bar.offsetHeight + 16) + 'px', 'important');
        }
      }
      update();
      var sidebar = root.querySelector('.cstm-bundle-content');
      if (sidebar && window.MutationObserver) {
        new MutationObserver(function () { window.requestAnimationFrame(update); })
          .observe(sidebar, { subtree: true, childList: true, characterData: true, attributes: true });
      }
      $(document).on('click', '#create-your-bundle', function () { setTimeout(update, 130); });
    })();
  }

  // Desktop type-in quantities (Zack): click the number in any +/- pill (character
  // cards AND the live bundle drawer) and type the amount you want. The typed value
  // is applied by replaying the SAME plus/minus clicks the engine already trusts —
  // so every rule (tier caps, auto-upgrade, pricing, drawer sync) behaves exactly
  // as if the shopper had clicked N times. Desktop only; mobile keeps tap-only.
  (function () {
    function bbDesk() { return window.matchMedia && window.matchMedia('(min-width: 768px)').matches; }
    $(document).on('focus', '#create-your-bundle .qtybox input', function () {
      if (!bbDesk()) { return; }
      var $in = $(this);
      $in.prop('readonly', false);
      $in.data('bb-typed-prev', parseInt($in.val(), 10) || 0);
      var el = this;
      setTimeout(function () { try { el.select(); } catch (e) {} }, 0);
    });
    $(document).on('keydown', '#create-your-bundle .qtybox input', function (e) {
      if (!bbDesk()) { return; }
      if (e.key === 'Enter') { e.preventDefault(); this.blur(); }
    });
    $(document).on('blur', '#create-your-bundle .qtybox input', function () {
      if (!bbDesk()) { return; }
      var $in = $(this);
      var prev = $in.data('bb-typed-prev');
      if (prev == null) { return; }
      $in.removeData('bb-typed-prev');
      var want = parseInt(String($in.val()).replace(/[^0-9]/g, ''), 10);
      if (isNaN(want) || want < 0) { want = prev; }
      if (want > 199) { want = 199; }                       // sanity ceiling
      var delta = want - prev;
      $in.val(prev);                                        // restore — the engine moves it via clicks
      if (!delta) { return; }
      var $box = $in.closest('.qtybox');
      var btn = (delta > 0)
        ? $box.find('.quantity-plus, [class*="plus"]').get(0)
        : $box.find('.quantity-minus, [class*="minus"]').get(0);
      if (!btn) { return; }
      for (var i = 0; i < Math.abs(delta); i++) { btn.click(); }
    });
  })();

  // Desktop chip row auto-size (Zack): the collection chips should be as LARGE as
  // possible while the whole row (search icon + every chip) always fits ONE line.
  // Scans font sizes top-down and sets --bb-chip-fs (desktop-only CSS reads it).
  (function () {
    function fitChips() {
      var root = document.getElementById('create-your-bundle');
      var track = document.querySelector('#create-your-bundle .bb-chiptrack');
      if (!root || !track) { return; }
      if (window.innerWidth < 768) { root.style.removeProperty('--bb-chip-fs'); return; }
      for (var fs = 19; fs >= 11; fs -= 0.5) {
        root.style.setProperty('--bb-chip-fs', fs + 'px');
        if (track.scrollWidth <= track.clientWidth + 1) { break; }
      }
    }
    var ct;
    window.addEventListener('resize', function () { clearTimeout(ct); ct = setTimeout(fitChips, 150); });
    window.addEventListener('load', fitChips);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function () { fitChips(); }); }
    if (document.readyState !== 'loading') { setTimeout(fitChips, 60); }
    else { document.addEventListener('DOMContentLoaded', function () { setTimeout(fitChips, 60); }); }
  })();

  // Auto-fit the per-collection "Add all" / "Add All … to Bundle" buttons (Zack):
  // the label must sit on ONE row on ANY screen — start from the stylesheet size
  // and shrink just enough to fit. Re-runs on resize/orientation/fonts, and the
  // buttons get max-width:100% in CSS so the container (not the text) caps their width.
  (function () {
    var MIN = 9.5;
    function fitButtons() {
      var btns = document.querySelectorAll('#create-your-bundle .bundle-add-all--top, #create-your-bundle .bundle-add-all--bottom');
      for (var i = 0; i < btns.length; i++) {
        var b = btns[i];
        if (!b.offsetParent) { continue; }              // hidden → skip
        b.style.whiteSpace = 'nowrap';
        b.style.fontSize = '';                          // reset so re-runs never compound
        var fs = parseFloat(getComputedStyle(b).fontSize) || 15;
        var guard = 0;
        while (b.scrollWidth > b.clientWidth + 1 && fs > MIN && guard++ < 40) {
          fs -= 0.5;
          b.style.fontSize = fs + 'px';
        }
      }
    }
    function init() {
      fitButtons();
      setTimeout(fitButtons, 600); setTimeout(fitButtons, 1600); // late-rendering groups
      var t = null;
      window.addEventListener('resize', function () {
        if (t) { clearTimeout(t); }
        t = setTimeout(fitButtons, 140);
      });
      window.addEventListener('orientationchange', function () { setTimeout(fitButtons, 220); });
      if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function () { fitButtons(); }); }
      window.addEventListener('load', fitButtons);
    }
    if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
  })();

  // Name formatting (Zack): a Wigglitz name is "Name (Type)". Put the NAME on its own first line and the
  // "(Type)" on the second line — on BOTH the character cards (.product-block__title-link) AND the bundle
  // drawer rows. Exception: if "(Type)" is too long to fit a line by itself (which would force THREE lines),
  // word-wrap it instead so the name shares line 1 with the type's first word (2 lines, never 3).
  (function () {
    function fmt(sel) {
      var els = document.querySelectorAll(sel);
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.querySelector('.ci-type')) continue;            // already formatted
        var m = (el.textContent || '').match(/^(.+?)\s+(\(.+\))$/);
        if (!m) continue;                                      // no "(type)" suffix → leave as-is
        el.innerHTML = '<span class="ci-name">' + m[1] + '</span> <span class="ci-type">' + m[2] + '</span>';
        var t = el.querySelector('.ci-type');
        var avail = el.clientWidth || (el.parentNode ? el.parentNode.clientWidth : 0);
        t.style.whiteSpace = 'nowrap';                          // keep "(Type)" together on its own line
        t.style.display = 'inline-block';
        t.style.fontSize = '';                                  // reset (re-runs shouldn't compound the shrink)
        if (avail) {                                            // shrink "(Type)" just enough to stay ONE line → never 3 lines
          var fs = parseFloat(getComputedStyle(t).fontSize) || 18, guard = 0;
          while (t.offsetWidth > avail && fs > 10.5 && guard++ < 40) { fs -= 0.5; t.style.fontSize = fs + 'px'; }
          // If it STILL can't fit on one line even at the floor size (rare long types like
          // "(Bernese Mountain Dog)" on the narrow 3-across cards), let it WRAP to a 2nd line
          // (3 lines total) rather than clip off the edge of the card (Zack).
          if (t.offsetWidth > avail) { t.style.whiteSpace = 'normal'; t.style.maxWidth = '100%'; }
        }
      }
    }
    var CARDS = '#create-your-bundle .product-block__title-link';
    var ROWS = '#create-your-bundle .ITGItemSelected .product-info p';

    // Row-aware breathing (Zack): on the mobile 2-across grid, if a card's ROW-MATE
    // already needs two lines for its name (e.g. "Abraham / (Abraham Lincoln)"), the
    // row is that tall anyway — so break this card's "(Type)" onto line 2 as well
    // ("Archie / (Wizard)") and let line 1 breathe. Rows where EVERY name fits on
    // one line (e.g. "Betsy (Cow)" next to "Blast (Popsicle)") stay one-liners.
    function rowBalance() {
      var isMobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
      var links = document.querySelectorAll(CARDS);
      var entries = [], i, e;
      for (i = 0; i < links.length; i++) {
        var el = links[i];
        var t = el.querySelector('.ci-type');
        if (!t) continue;
        t.classList.remove('bb-line2');                        // back to natural flow before measuring
        if (!isMobile) continue;                               // desktop: natural flow only
        var card = el.closest ? el.closest('.product-block') : null;
        if (!card || !card.offsetParent) continue;             // hidden (filtered out) → skip
        entries.push({ t: t, name: el.querySelector('.ci-name'), card: card });
      }
      if (!isMobile || entries.length < 2) return;
      // READ pass (all measuring before any writes, so rows group consistently)
      for (i = 0; i < entries.length; i++) {
        e = entries[i];
        var nr = e.name.getBoundingClientRect(), tr = e.t.getBoundingClientRect();
        e.top = e.card.getBoundingClientRect().top;
        e.twoLine = (tr.top - nr.top) > (nr.height / 2);       // "(Type)" already sits on a lower line
      }
      // group cards into visual rows (same top, small tolerance)
      var rows = [];
      for (i = 0; i < entries.length; i++) {
        e = entries[i];
        var placed = false;
        for (var r = 0; r < rows.length; r++) {
          if (Math.abs(rows[r][0].top - e.top) <= 6) { rows[r].push(e); placed = true; break; }
        }
        if (!placed) { rows.push([e]); }
      }
      // WRITE pass: any two-liner in the row → its one-line row-mates break too
      for (r = 0; r < rows.length; r++) {
        var row = rows[r];
        if (row.length < 2) continue;
        var anyTwo = false;
        for (i = 0; i < row.length; i++) { if (row[i].twoLine) { anyTwo = true; break; } }
        if (!anyTwo) continue;
        for (i = 0; i < row.length; i++) { if (!row[i].twoLine) { row[i].t.classList.add('bb-line2'); } }
      }
    }

    function all() { fmt(CARDS); fmt(ROWS); rowBalance(); }
    function init() {
      all();
      setTimeout(all, 500); setTimeout(all, 1500);             // catch cards / cart rows that render a beat later
      var sb = document.querySelector('#create-your-bundle .cstm-bundle-content');
      if (sb && window.MutationObserver) {
        new MutationObserver(function () { window.requestAnimationFrame(function () { fmt(ROWS); }); })
          .observe(sb, { subtree: true, childList: true });    // cart rows re-render inside the drawer
      }
      var rbTimer = null;
      window.addEventListener('resize', function () {          // row pairings change with width
        if (rbTimer) { clearTimeout(rbTimer); }
        rbTimer = setTimeout(rowBalance, 120);
      });
      window.addEventListener('orientationchange', function () { setTimeout(rowBalance, 200); });
      if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function () { rowBalance(); }); }
      window.addEventListener('load', function () { rowBalance(); });
    }
    if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
  })();

  // Desktop back-to-top (Zack): floating round button, bottom-right, appears after
  // scrolling past the intro; smooth-scrolls home. Desktop only (CSS hides it on mobile).
  (function () {
    if (!document.getElementById('create-your-bundle')) { return; }
    var topBtn = document.createElement('button');
    topBtn.type = 'button';
    topBtn.id = 'bb-toptop';
    topBtn.setAttribute('aria-label', 'Back to top');
    topBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 14 12 8 18 14"></polyline></svg><span>Back to top</span>';
    document.body.appendChild(topBtn);
    topBtn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    function topTick() {
      if (!window.matchMedia('(min-width: 768px)').matches) { topBtn.classList.remove('is-on'); return; }
      // Show while browsing the character section: the collections bar is pinned to
      // the top. The pill hangs centered just below that bar.
      var bar = document.querySelector('#create-your-bundle .cst_bndl_search_mn');
      var show = false;
      if (bar) {
        var r = bar.getBoundingClientRect();
        var st = parseFloat(getComputedStyle(bar).top); if (isNaN(st)) { st = 0; }
        show = r.top <= st + 2 && (window.pageYOffset || 0) > 300;
        if (show) {
          topBtn.style.top = Math.round(r.bottom + 12) + 'px';
          // center over the CHARACTER COLUMN, not the whole viewport (the sidebar
          // makes viewport-center look off-center)
          var grid = document.querySelector('#create-your-bundle .cstm-bundle-product-grid_mn');
          var gx = grid ? grid.getBoundingClientRect() : r;
          topBtn.style.left = Math.round(gx.left + gx.width / 2) + 'px';
        }
      }
      topBtn.classList.toggle('is-on', show);
    }
    window.addEventListener('scroll', topTick, { passive: true });
    window.addEventListener('resize', topTick);
    topTick();
  })();

  // Choking warning wording (Zack): desktop has room for "3 years." — only mobile
  // keeps the compact "3 yrs." (its one-line auto-fit depends on the short text).
  (function () {
    function applyYears() {
      var el = document.querySelector('#create-your-bundle .itg-cutsom-text');
      if (!el) { return; }
      var desk = window.matchMedia && window.matchMedia('(min-width: 768px)').matches;
      var h = el.innerHTML;
      if (desk && / yrs\.?/.test(h)) { el.innerHTML = h.replace(/ yrs\.?/, ' years.'); }
      else if (!desk && / years\.?/.test(h)) { el.innerHTML = h.replace(/ years\.?/, ' yrs.'); }
    }
    var yt;
    window.addEventListener('resize', function () { clearTimeout(yt); yt = setTimeout(applyYears, 180); });
    if (document.readyState !== 'loading') { applyYears(); } else { document.addEventListener('DOMContentLoaded', applyYears); }
    setTimeout(applyYears, 800);
  })();

  // Auto-fit the choking-hazard warning (Zack): pick the LARGEST font that fills its width on ONE line,
  // clamped to a sensible range. Recomputes on resize/orientation — so it's as big as fits on any phone,
  // and noticeably bigger (but not silly) on a wide desktop.
  (function () {
    var MIN = 11, MAX = 20, PAD = 6;   // px: font floor/ceiling; PAD = a little breathing room inside the width
    function fit() {
      var el = document.querySelector('#create-your-bundle .itg-cutsom-text');
      if (!el) return;
      if (!window.matchMedia || !window.matchMedia('(max-width: 767px)').matches) {
        el.style.fontSize = ''; el.style.whiteSpace = '';  // PHONES ONLY (Zack): desktop keeps the CSS 16px size
        return;
      }
      if (!el.offsetParent) return;                        // hidden → skip
      var cs = getComputedStyle(el);
      var pad = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
      var avail = el.clientWidth - pad - PAD;
      if (avail <= 0) return;
      var prevFS = el.style.fontSize;
      el.style.whiteSpace = 'nowrap';
      el.style.fontSize = '100px';
      var textW = el.scrollWidth - pad;                    // text width at the 100px reference
      el.style.fontSize = prevFS;
      if (!textW) return;
      var px = Math.max(MIN, Math.min(MAX, Math.floor(avail / textW * 1000) / 10));
      el.style.fontSize = px + 'px';
      el.style.whiteSpace = 'nowrap';                      // hold it on one line at the fitted size
    }
    var raf;
    function schedule() { if (raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(fit); }
    function init() {
      fit(); setTimeout(fit, 300); setTimeout(fit, 1200);  // re-fit after fonts/layout settle
      window.addEventListener('resize', schedule);
      window.addEventListener('orientationchange', schedule);
    }
    if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
  })();

  // Auto-fit the "Build Your Bundle" H1 (Zack): the LARGEST font that still fits ONE line on any phone, with a
  // proportional line-height so there's no leftover leading at the fitted size. Phones only; desktop keeps its CSS.
  (function () {
    var MIN = 24, MAX = 50, PAD = 8;
    function fit() {
      var el = document.querySelector('#create-your-bundle .product-detail__title');
      if (!el) return;
      if (!window.matchMedia || !window.matchMedia('(max-width: 767px)').matches) {
        el.style.fontSize = ''; el.style.lineHeight = ''; el.style.whiteSpace = ''; return;
      }
      if (!el.offsetParent) return;
      var avail = el.clientWidth - PAD;
      if (avail <= 0) return;
      var prev = el.style.fontSize;
      el.style.whiteSpace = 'nowrap';
      el.style.fontSize = '100px';
      var w = el.scrollWidth;
      el.style.fontSize = prev;
      if (!w) return;
      var px = Math.max(MIN, Math.min(MAX, Math.floor(avail / w * 1000) / 10));
      el.style.fontSize = px + 'px';
      el.style.lineHeight = '1.05';
      el.style.whiteSpace = 'nowrap';
    }
    var raf;
    function schedule() { if (raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(fit); }
    function init() {
      fit(); setTimeout(fit, 300); setTimeout(fit, 1200);
      window.addEventListener('resize', schedule);
      window.addEventListener('orientationchange', schedule);
    }
    if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
  })();

  // Drag-up-to-open (Zack): the closed bar FOLLOWS your finger upward and snaps the drawer open — a real swipe
  // feel, not an instant jump. A plain tap still opens via the bar's toggle/peek handlers (we only take over
  // once the finger actually moves up). Touch only.
  (function () {
    var drawer = document.querySelector('#create-your-bundle .cstm-bundle-content');
    if (!drawer) return;
    var sY = 0, up = 0, tracking = false, revealing = false, HIDE = 0;
    var COMMIT = 44; // px of upward drag before it commits to fully open
    function isOpen() { return drawer.classList.contains('open-popupBar'); }
    function bar(t) { return t && t.closest ? t.closest('#bb-stickybar') : null; }
    function settle() {                                    // pad the drawer so the last item clears the sticky bar
      var sb = document.getElementById('bb-stickybar');
      if (sb && sb.offsetHeight) drawer.style.setProperty('padding-bottom', (sb.offsetHeight + 16) + 'px', 'important');
    }
    function snapOpen() {
      revealing = false; tracking = false;
      drawer.style.transition = 'transform .26s cubic-bezier(.22,.61,.36,1)';
      drawer.style.transform = 'translateY(0px)';
      document.body.classList.add('Bnd-overflow-hiddan');
      setTimeout(function () { drawer.style.transition = ''; drawer.style.transform = ''; settle(); }, 280);
    }
    function snapClosed() {
      revealing = false; tracking = false;
      drawer.style.transition = 'transform .2s ease';
      drawer.style.transform = 'translateY(' + (HIDE || 700) + 'px)';
      setTimeout(function () {
        drawer.classList.remove('open-popupBar');
        drawer.style.transition = ''; drawer.style.transform = '';
      }, 205);
    }
    document.addEventListener('touchstart', function (e) {
      tracking = false; revealing = false; up = 0;
      var b = bar(e.target);
      if (!b || isOpen()) return; // only a CLOSED bar -- opens even when empty (shows the empty note)
      sY = e.touches[0].clientY; tracking = true;
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      if (!tracking) return;
      up = sY - e.touches[0].clientY;                       // positive = dragged upward
      if (up <= 2) { if (revealing) snapClosed(); return; } // dragged back down -> let it go
      if (e.cancelable) e.preventDefault();                 // own the vertical drag so the page can't scroll behind
      if (!revealing && up > 6) {                           // finger has clearly moved up -> begin the reveal
        revealing = true;
        HIDE = window.innerHeight || drawer.offsetHeight || 700;
        drawer.style.transition = 'none';
        drawer.classList.add('open-popupBar');
        drawer.style.transform = 'translateY(' + HIDE + 'px)';
        void drawer.offsetHeight;
      }
      if (revealing) {
        drawer.style.transform = 'translateY(' + Math.max(0, HIDE - up) + 'px)'; // rises 1:1 with the finger
      }
    }, { passive: false });
    function end() {
      if (!tracking) return; tracking = false;
      if (!revealing) return;
      if (up > COMMIT) snapOpen(); else snapClosed();
    }
    document.addEventListener('touchend', end, { passive: true });
    document.addEventListener('touchcancel', end, { passive: true });
  })();

  // Drag-down-to-close (Zack): when the open drawer's list is at the very TOP, a further downward pull grabs the
  // drawer and FOLLOWS your finger down to dismiss it. Checks whether anything under the finger can still scroll
  // up first, so it only engages on a true over-pull at the top — never steals a normal scroll.
  (function () {
    function init() {
      var drawer = document.querySelector('#create-your-bundle .cstm-bundle-content');
      if (!drawer) return;
      var startY = 0, dy = 0, armed = false;
      var ENGAGE = 14;   // px of downward pull before we take over (tiny touches pass straight through)
      var CLOSE_AT = 90; // px pulled (beyond ENGAGE) before it dismisses
      function isOpen() { return drawer.classList.contains('open-popupBar'); }
      function canScrollUp(el) {                       // any scrollable ancestor still has room above?
        while (el && el !== drawer.parentNode) {
          if (el.scrollTop > 0) return true;
          el = el.parentNode;
        }
        return false;
      }
      drawer.addEventListener('touchstart', function (e) {
        armed = false; dy = 0;
        if (!isOpen() || canScrollUp(e.target)) return;   // list can still scroll up -> leave it alone
        startY = e.touches[0].clientY; armed = true;
        drawer.style.transition = 'none';
      }, { passive: true });
      drawer.addEventListener('touchmove', function (e) {
        if (!armed) return;
        dy = e.touches[0].clientY - startY;
        if (dy <= 0) { armed = false; drawer.style.transform = ''; drawer.style.transition = ''; return; } // scrolling down -> release
        if (dy < ENGAGE) return;                        // small — don't take over yet
        e.preventDefault();                             // committed to the pull-down
        drawer.style.transform = 'translateY(' + Math.min((dy - ENGAGE) * 0.7, 320) + 'px)';
      }, { passive: false });
      function release() {
        if (!armed) return; armed = false;
        if (dy - ENGAGE > CLOSE_AT) {
          drawer.style.transition = 'transform .2s ease';
          drawer.style.transform = 'translateY(100%)';
          setTimeout(function () {
            drawer.style.transition = 'none';
            var a = document.querySelector('#create-your-bundle .mobile_sc_arrow');
            if (a) { a.click(); }
            drawer.style.transform = '';
            void drawer.offsetHeight;
            drawer.style.transition = '';
          }, 200);
        } else {
          drawer.style.transition = 'transform .2s ease';
          drawer.style.transform = '';
          setTimeout(function () { drawer.style.transition = ''; }, 210);
        }
      }
      drawer.addEventListener('touchend', release, { passive: true });
      drawer.addEventListener('touchcancel', release, { passive: true });
    }
    if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
  })();

  // Bundle: tap-to-reveal hover image on touch devices.
  // Driving the swap via :hover causes iOS Safari sticky-hover (next tap
  // anywhere is wasted clearing hover instead of firing the click). On
  // touch we toggle .is-flipped instead — see the matching CSS in
  // custom.css `@media (hover: hover)` block.
  if (window.matchMedia && window.matchMedia('(hover: none)').matches) {
    $(document).on('click', function (e) {
      var $bundle = $('#create-your-bundle');
      if (!$bundle.length) return;
      var $tapped = $(e.target).closest('.hover-images--two', $bundle[0]);
      if ($tapped.length) {
        $bundle.find('.hover-images--two.is-flipped').not($tapped).removeClass('is-flipped');
        $tapped.toggleClass('is-flipped');
      } else {
        $bundle.find('.hover-images--two.is-flipped').removeClass('is-flipped');
      }
    });
  }

  $(document).on('click', '#create-your-bundle .itg_remove', function () { // DELEGATED 2026-09-01: page-2 cards are spliced in after load
    bundleCeiling = 0;
    localStorage.removeItem('bundleCeiling');

    $('.ITGItemSelected').each(function (index, value) {
      let productHandle = $(value).attr('product-handle');
      localStorage.removeItem(`bundle ${productHandle}`);
    })

    $('.bundle_cart_main_sec').html(" ");

    $('.cstm-addtocart-btn input').prop('checked', false);

    var selectedItemCount = $('.cstm-addtocart-btn input:checked').length;
    console.log(selectedItemCount);
    var totalItemCount = $('.cstm-addtocart-btn input').length;
    var selectedBundleItemCount = $(document).find('.bundle_cart_main_sec .ITGItemSelected').length;
    console.log(selectedBundleItemCount);
    if (selectedItemCount == selectedBundleItemCount) {
      $('.ITG_Product_description').find('.qtybox input').val(0).attr('value', 0);
      $('.ITG_Product_description').find('.DefaultAddBtn').prop('checked', false); // Corrected selector
    }

    $('.ITG_Product_description .qtybox').hide();
    $('.ITG_Product_description .cstm-addtocart-btn').show();
    $('.ITG_Product_description .cstm-addtocart-btn input').val("");
    $('.ITG_Product_description .cstm-addtocart-btn input').attr("value", "");

    variantOption();
    nextTarget();

  });

  loadStoredData();
  loadStoredValues();
  // ARM B (2026-08-25): snap the SELECTED size to the smallest tier that fits n,
  // reading tiers live from bbTiers(). Replaces two hardcoded gen-1 chains
  // ("6/15/50 Wigglitz" string clicks) that silently no-op'd on this product's
  // 7/20/32/65 values and left the selection stuck on the wrong tier.
  function bbSnapB(n) {
    var tiers = bbTiers();
    var pick = tiers[tiers.length - 1];
    for (var i = 0; i < tiers.length; i++) { if (n <= tiers[i].q) { pick = tiers[i]; break; } }
    $('.dot').removeClass('highlight');
    $('.option-selector__btns input[value="' + pick.q + ' Wigglitz"]').trigger('click').prop('checked', true);
    $('.dot[data-value="' + pick.q + '"]').addClass('highlight');
    $(document).find('.count_select').text(pick.q);
  }
  $(document).on('change', '.option-selector__btns input', function () {
    var thisValue = $('.option-selector__btns input:checked').val();
    var previousTarget = parseInt($(document).find('.count_select').html());
    var currentTargetproduct = parseInt($(document).find('.quantity-content').html());
    if (variantOption() >= currentTargetproduct) {
      bbSnapB(variantOption());
    } else {
      $(document).find('.WarningAlertPopup').css('display', 'none'); // popup replaced by inline button message (reconcileBundleButton)
      $(document).find('.currentselectedVal').text(variantOption());
      $(document).find('.alreadyselectedval').text(currentTargetproduct)
      bbSnapB(previousTarget);
    }
    updateCartButton(totalQuantity);
    nextTarget();
  });
  $(document).on("click", "#create-your-bundle .DefaultAddBtn", function () { // DELEGATED 2026-09-01: a direct bind left spliced-in cards inert
    // $(this).closest('.cstm-addtocart-btn').hide();
    // $(this).closest('.ITG_Product_description').find('.qtybox').show();
    // $(this).closest('.ITG_Product_description').find('.qtybox input').val(1).attr('value',1)
    // apendData($(this));
    //  nextTarget();

    // ============================ code by (R) start=============================== //
    // 50+ bundles allowed: no upper cap. Extras beyond 50 are billed via the
    // hidden "Extra Wigglitz" product ($1.20 ea) at add-to-cart.
    $(this).closest('.cstm-addtocart-btn').hide();
    $(this).closest('.ITG_Product_description').find('.qtybox').show();
    $(this).closest('.ITG_Product_description').find('.qtybox input').val(1).attr('value', 1)
    apendData($(this));
    nextTarget();
    // ============================ code by (R) End=============================== //
  });



  $(document).on('click', '.ITGQtyAdjust', function () {
    adjustQty($(this))
    nextTarget();
  });

  // clear Cart Function
  function clearcart() {
    console.log("cart function");
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      data: '',
      dataType: 'json',
      success: function () {
      },
      error: function (XMLHttpRequest, textStatus) {
      }
    });
  }
  // function for default add button 
  function apendData(element, event) {
    var productImage = element.attr("data_img");
    var productTitle = element.attr("title");
    var productHandle = element.attr("dataval");
    var QtyInput = element.closest('.ITG_Product_description').find('.qtydiv').html();
    var MainQty = element.closest('.ITG_Product_description').find('.qtydiv input').val();
    // var MainQty2 = element.closest('.ITG_Product_description').find('.qtydiv input').attr('value');
    if (element.is(":checked")) {
      var inputchecked = true
    } else {
      var inputchecked = false
    }
    var removeBtn = '';
    // Add remove button for mystery-wigglitz product
    // if (productHandle === 'mystery-wigglitz') {
    //     removeBtn = `<button class="remove-mystery-wigglitz" data-handle="${productHandle}">x</button>`;
    // }
    if ($('.bundle_cart_main_sec').find(`[product-handle="${productHandle}"]`).length === 0) {
      var productsData = `
      <div class="ITGItemSelected" product-handle="${productHandle}">
        <div class="product-info">
          <img src='${productImage}' alt="Product Image">
          <p>${productTitle}</p>
        </div>
        <div class="selectedItemQty">${QtyInput}</div>
        ${removeBtn}
      </div>`
      // Check if the product is 'mystery-wigglitz' and append it to the end
      if (productHandle === 'mystery-wigglitz') {
        $('.bundle_cart_main_sec').append(productsData);
      } else {
        $('.bundle_cart_main_sec').prepend(productsData);
      }
      if (event != 'onload') {
        localStorage.setItem(`bundle ${productHandle}`, `${MainQty}&&${inputchecked}`);
      }

      $('.ITGItemSelected .selectedItemQty input').each(function () {
        let getQuanty = localStorage.getItem(`bundle ${productHandle}`).split("&&");
        let getQuantityLS = parseInt(getQuanty[0]);
        if (productHandle == $(this).attr('data-id'))
          $(this).val(getQuantityLS);
      });

      // $(this).closest('.product-block.col_bundle_sec').find('.qtydiv').show();
    }
  }

  // function for adjust qty
  function adjustQty(target) {
    var opration = target.attr('btnfor');
    var productHandle = target.closest('.qtybox').find('input').attr('data-id');
    var productTitle = target.closest('.qtybox').attr('data-title');
    var quantityInput = $(`.quantity-input[data-id='${productHandle}']`);
    var quantity = parseInt(quantityInput.val());
    var totalSelectedItemsCount = 0;
    $('.ITG_Product_description').find('.qtybox input').each(function () {
      totalSelectedItemsCount += parseInt($(this).val());
    });
    if (opration == 'minus') {
      quantity--;
    } else {
      // 50+ bundles allowed: no upper cap (extras billed via Extra Wigglitz).
      quantity++;
    }
    quantityInput.val(quantity).attr('value', quantity);

    // Update hidden input field
    var hiddenInput = $(`.product-block.col_bundle_sec[data-id='${productHandle}'] .cs-line-item-property__field.cstm-addtocart-btn input`);
    var newValue = `${quantity}*${productTitle}`;
    // $(document).find(`.cstm-addtocart-btn:has([dataval="${productHandle}"])`).find('input').prop('checked',true)
    if (quantity <= 0) {
      $(document).find(`.cstm-addtocart-btn:has([dataval="${productHandle}"])`).show();
      $(document).find(`.cstm-addtocart-btn:has([dataval="${productHandle}"])`).find('input').prop('checked', false)
      $(document).find(`.qtybox:has([data-id="${productHandle}"])`).hide();
      $(document).find(`.bundle_cart_main_sec [product-handle='${productHandle}']`).remove();
      hiddenInput.val('');
      localStorage.removeItem(`bundle ${productHandle}`);
    }
    //$(document).find(`input[data-id='${productHandle}']`).val(quantity).attr('value',quantity);
    else {
      // Update hidden input with new value
      hiddenInput.val(newValue);
      localStorage.setItem(`bundle ${productHandle}`, `${quantity}&&true`);
    }
  }
  // function for check next target 
  function nextTarget(target) {
    var totalSelectedItemsCount = 0;
    $('.ITG_Product_description').find('.qtybox input').each(function () {
      var ThisItemCount = parseInt($(this).val()) || 0;
      totalSelectedItemsCount += ThisItemCount;
    });
    $(document).find('.quantity-content').text(totalSelectedItemsCount);
    $('.dot').removeClass('highlight');
    // Past the top tier -> open "65+" mode (label/price handled in updateCartButton),
    // unless the shopper explicitly picked a smaller size (downsize flow).
    if (totalSelectedItemsCount > bbTierQ(3) && bundleDownsizeTarget <= 0) {
      $('.option-selector__btns input[value="' + bbTierQ(3) + ' Wigglitz"]').trigger('click').prop('checked', true);
      updateCartButton(totalSelectedItemsCount);
      return;
    }
    // Tier = smallest that fits the count, but never below the chosen ceiling,
    // so picking "50" then Mystery Fill completes all the way to 50.
    var tier = bundleEffectiveTier(totalSelectedItemsCount);
    $('.option-selector__btns input[value="' + tier + ' Wigglitz"]').trigger('click').prop('checked', true);
    $('.dot[data-value="' + tier + '"]').addClass('highlight');
    $(document).find('.count_select').text(tier);
    updateCartButton(totalSelectedItemsCount);
  }
  function updateCartButton(totalQuantity) {
    // Always use the REAL current count — some callers pass a stale/empty value,
    // which let the button desync from the actual bundle.
    totalQuantity = 0;
    $('.ITG_Product_description .qtybox input').each(function () { totalQuantity += (parseInt($(this).val()) || 0); });
    // Helper prompt: celebrate the best-value tier at 50+, else the normal prompt
    // (suppressed mid-downsize — reconcile owns the "remove N" message then).
    if (totalQuantity >= bbTierQ(3) && bundleDownsizeTarget <= 0) {
      if (bundleHeadingMode !== 'congrats') {
        $('.bundle-sidebar__heading').html(BUNDLE_CONGRATS_HTML);
        bundleHeadingMode = 'congrats';
      }
    } else if (bundleHeadingMode === 'congrats') {
      $('.bundle-sidebar__heading').html(bundleHeadingOriginalHTML);
      bundleHeadingMode = 'normal';
    }
    let variant_price = $(".option-selector__btns input:checked").attr("variant_price");
    // ARM B: 65+ mode — the 65 bundle (its live variant price) is the base, each
    // extra bills at BB_EXTRA_EACH via "Additional Wigglitz (Beyond 64)". The real
    // charge comes from the actual cart line items, so checkout is always correct.
    if (totalQuantity > bbTierQ(3) && bundleDownsizeTarget <= 0) {
      var $v50 = $('.option-selector__btns input[value="' + bbTierQ(3) + ' Wigglitz"]');
      if (!$v50.is(':checked')) { $v50.trigger('click'); }
      var base50 = parseFloat(($v50.attr('variant_price') || '').replace(/[^0-9.]/g, '')) || bbTiers()[3].price;
      var extras50 = totalQuantity - bbTierQ(3);
      var totalPrice50 = base50 + (extras50 * BB_EXTRA_EACH);
      var totalPriceStr50 = '$' + totalPrice50.toFixed(2);
      $('.custom-add-to_cart').addClass('add-to_cart-disabled').text('Add to Cart - ' + totalPriceStr50);
      $('[data-product-detail-price] .theme-money').text(totalPriceStr50);
      $('.Srm-quantity_box-add').hide();
      $('.Srm_desk_qty').show();
      $('.dot').removeClass('highlight');
      $('.dot[data-value="' + bbTierQ(3) + '"]').addClass('highlight');
      $('span.count_select').text(bbTierQ(3) + '+');
      return;
    }
    if (totalQuantity == bundleEffectiveTier(totalQuantity)) {
      $('.custom-add-to_cart').addClass('add-to_cart-disabled');
      $('.custom-add-to_cart').text('Add to Cart - ' + variant_price);
      $('.Srm-quantity_box-add').hide();
      $('.Srm_desk_qty').show();
    } else {
      $('.custom-add-to_cart').removeClass('add-to_cart-disabled');
      $('.custom-add-to_cart').html('<span>Please select at least <span class="count_select">15</span> products</span>');
      $('.Srm-quantity_box-add').show();
      $('.Srm_desk_qty').hide();
    }
    // Highlight + select the tier the shopper is committed to: smallest tier that
    // fits the count, but never below a tier they explicitly chose (the ceiling).
    if (totalQuantity >= 1 && totalQuantity <= 50) {
      var effTier = bundleEffectiveTier(totalQuantity);
      $('.dot').removeClass('highlight');
      $('.dot[data-value="' + effTier + '"]').addClass('highlight');
      var $effRadio = $('.option-selector__btns input[value="' + effTier + ' Wigglitz"]');
      $effRadio.trigger("click");
      // Force the cart form's id to the shown tier so the charged price can never
      // desync from what's highlighted/selected.
      var effId = $effRadio.attr('data-variant-id');
      if (effId) { $('form[action*="/cart/add"] select[name="id"], form[action*="/cart/add"] input[name="id"]').val(effId); }
      $('span.count_select').text(effTier);
    }
  }
  // function totalCountSelection
  function variantOption() {
    // The size value string leads with the quantity ("36 Wigglitz" -> 36), so this
    // survives variant renames without a code change.
    const selectedVariant = $('.option-selector__btns input:checked').val() || '';
    var targetQuantity = parseInt(selectedVariant, 10) || 0;
    $(document).find('.count_select').text(targetQuantity);
    return targetQuantity;
  }
  // function for reset selection
  function resetBundle() {
    var selectedItemCount = $('.cstm-addtocart-btn input:checked').length;
    var totalItemCount = $('.cstm-addtocart-btn input').length;
    var selectedBundleItemCount = $(document).find('.bundle_cart_main_sec .ITGItemSelected').length;
    if (selectedItemCount == selectedBundleItemCount && selectedBundleItemCount == totalItemCount) {
      $('.ITG_Product_description').find('.qtybox input').val(0).attr('value', 0);
      $('.ITG_Product_description').find('.DefaultAddBtn').prop('checked', false); // Corrected selector
    }
    console.log(`${selectedItemCount} == ${totalItemCount}== ${selectedBundleItemCount}`)
  }
  //if (productHandle === 'mystery-wigglitz') {
  // $(document).on('click', '.remove-mystery-wigglitz', function () {
  //        var productHandle = $(this).attr('data-handle');
  //    $(document).find(`.cs-line-item-property__field input[dataval='${productHandle}']`).val('').attr('value', '');
  //    $(document).find(`.ITG_Product_description input[data-id='${productHandle}']`).val('0').attr('value', '0');
  //    $(document).find(`.cstm-addtocart-btn:has([dataval="${productHandle}"])`).show();
  //    $(document).find(`.cstm-addtocart-btn:has([dataval="${productHandle}"])`).find('input').prop('checked', false);
  //    $(document).find(`.qtybox:has([data-id="${productHandle}"])`).hide();
  //        // Remove the product element from the DOM
  //        $(`.bundle_cart_main_sec [product-handle="${productHandle}"]`).remove();
  //        // Remove the product from local storage
  //        localStorage.removeItem(`bundle ${productHandle}`);
  //   //updateQuantityContent();
  //    nextTarget();
  //    });

  // for rendom button event 
  $(document).on('click', '.random-button', function () {
    var currentTargetproducts = parseInt($(document).find('.quantity-content').html());
    var countTargetproducts = parseInt($(document).find('.count_select').html());
    // Mystery Fill doesn't apply once past the 50 bundle (50+ mode).
    if (currentTargetproducts > bbTierQ(3)) { return; }
    if (currentTargetproducts === countTargetproducts || currentTargetproducts === countTargetproducts || currentTargetproducts === countTargetproducts || currentTargetproducts === countTargetproducts) {
      //alert('Random click is disabled for this quantity content: ' + currentTargetproducts);
      return; // Prevent further action
    }
    // Gather and reset existing product handles
    let productHandles = [];
    $('.bundle_cart_main_sec .ITGItemSelected').each(function () {
      productHandles.push($(this).attr('product-handle'));
    });

    resetBundle();
    $('.bundle_cart_main_sec').html('');
    let productCount = {}; // Object to store product counts
    let totalProductsAdded = 0; // Variable to keep track of total products added
    variantOption();
    var itemsfixCount = 0;
    $(document).find('.cstm-addtocart-btn input:checked').each(function () {
      var itemsfix = parseInt($(this).closest('.ITG_Product_description').find('.qtybox input').val());
      itemsfixCount += itemsfix;
      apendData($(this));
    });

    var remainingQty = variantOption() - itemsfixCount;
    if (remainingQty > 0) {
      var mysteryProduct = $(document).find('.cstm-addtocart-btn input[dataval="mystery-wigglitz"]');
      mysteryProduct.closest('.cstm-addtocart-btn').hide();
      mysteryProduct.closest('.ITG_Product_description').find('.qtybox').show();
      mysteryProduct.closest('.ITG_Product_description').find('.qtybox input').val(remainingQty).attr('value', remainingQty);
      apendData(mysteryProduct);
    }
    reorderProducts(productHandles);
    // Update the value of the input fields inside cs-line-item-property__field for mystery-wigglitz
    $(document).find('.cs-line-item-property__field').each(function () {
      var inputField = $(this).find('input');

      // Check if this is related to the mystery-wigglitz product
      if ($(this).closest('.product-block.cstm_product.col_bundle_sec').find('.product-block__title-link').text().trim() === 'Mystery Wigglitz') {
        var productTitle = 'Mystery Wigglitz'; // Directly use the title if you are sure it matches
        var newValue = remainingQty + '*' + productTitle; // Combine quantity and product title

        // alert(newValue); // For debugging, remove or comment out in production
        inputField.val(newValue).attr('value', newValue);
      }
    });
    nextTarget();
  });

  // Function to reorder products to maintain the original order
  function reorderProducts(productHandles) {
    productHandles.forEach(handle => {
      var productElement = $('.bundle_cart_main_sec').find(`[product-handle="${handle}"]`);
      if (productElement.length) {
        productElement.detach().appendTo('.bundle_cart_main_sec');
      }
    });

    // Ensure 'mystery-wigglitz' is at the bottom
    var mysteryProduct = $('.bundle_cart_main_sec').find(`[product-handle="mystery-wigglitz"]`);
    if (mysteryProduct.length) {
      mysteryProduct.detach().appendTo('.bundle_cart_main_sec');
    }
  }

  $('#create-your-bundle .cstm-tab-btn').click(function () {
    clearPreviousTabValues();
    $('.quantity-input').val(0);
    $('.bundle_cart_main_sec').html('');
    let tagName = $(this).attr('data-tab-content');
    let productCount = {}; // Object to store product counts
    let totalProductsAdded = 0; // Variable to keep track of total products added
    var productId = $(this).closest('.col_bundle_sec').find(".qtydiv").attr("data-id");
    let maxProducts = 0;
    // Find the checked variant and log its value
    const selectedVariant = $('.option-selector__btns input:checked').val();
    console.log(`Selected Variant: ${selectedVariant}`);
    // Check the value of the selected variant
    // Quantity leads the value string ("36 Wigglitz" -> 36) — rename-proof.
    maxProducts = parseInt(selectedVariant, 10) || 0;
    //  alert(`Max Products to Add: ${maxProducts}`);
    $('.product-block.col_bundle_sec').each(function () {
      let proTag = $(this).data('tab-tag');
      var productId = $(this).find(".qtydiv").attr("data-id");
      // Check if maximum products are reached
      if (totalProductsAdded >= maxProducts) return false;
      if (proTag.includes(tagName)) {
        $(this).find('.cstm-addtocart').trigger('click'); // Simulate click to add product
        $(this).find('.quantity-selector').val(1); // Set quantity to 1 for matching products
        // Increment the count for the current product ID
        productCount[productId] = (productCount[productId] || 0) + 1;
        totalProductsAdded++;
        // Update UI for the added product
        apendData($(this).find(".cstm-addtocart-btn input"));
        // Check the quantity value after appending data
        var qtyValue = parseInt($(this).find(".quantity-selector").val());
        if (qtyValue > 0) {
          $(this).find(".cstm-addtocart-btn").hide(); // Hide add-to-cart button if quantity is greater than 0
          $(this).find(".qtybox").show(); // Show quantity box if quantity is greater than 0
        } else {
          $(this).find(".cstm-addtocart-btn").show(); // Show add-to-cart button if quantity is 0
          $(this).find(".qtybox").hide(); // Hide quantity box if quantity is 0
        }
      } else {
        $(this).find('.quantity-selector').val(0); // Reset quantity to 0 for products not matching current tag
        $(this).find(".cstm-addtocart-btn").show(); // Show add-to-cart button for products not matching current tag
        $(this).find(".qtybox").hide(); // Hide quantity box for products not matching current tag
      }
    });
    // After processing products, ensure checkboxes are unchecked for products with quantity 0
    $('.cstm-addtocart-btn input').each(function () {
      var $checkbox = $(this);
      var $productBlock = $checkbox.closest('.product-block.col_bundle_sec');
      var $quantitySelector = $productBlock.find('.quantity-selector');

      if ($quantitySelector.val() == 0 || !$checkbox.prop('checked')) {
        $checkbox.prop('checked', false);
        $checkbox.val('');
        var hiddenInput = $productBlock.find('.cs-line-item-property__field.cstm-addtocart-btn input');
        hiddenInput.val('');
      }
    });
    // If the selected variant is "Small (about 15)" and fewer than 15 products are added, repeat the available products until 15 products are added
    if (totalProductsAdded < maxProducts) {
      var availableProductIds = Object.keys(productCount);
      var availableProductCount = availableProductIds.length;
      for (let i = totalProductsAdded; i < maxProducts; i++) {
        var productIdToAdd = availableProductIds[i % availableProductCount];
        productCount[productIdToAdd] = (productCount[productIdToAdd] || 0) + 1;
        totalProductsAdded++;
      }
    }
    // Update the quantity input fields with the count for each product ID
    for (var productId in productCount) {
      var quantityInput = $(`.quantity-input[data-id="${productId}"]`);
      if (quantityInput.length > 0) {
        var productTitle = $(`.product-block.col_bundle_sec[data-id="${productId}"] .qtybox`).attr("data-title");
        var newValue = `${productCount[productId]}*${productTitle}`;
        var newIntValue = parseInt(productCount[productId]);
        quantityInput.val(newIntValue);
        quantityInput.attr('value', newIntValue);
        // Update the value of the hidden input field
        var hiddenInput = $(`.product-block.col_bundle_sec[data-id="${productId}"] .cs-line-item-property__field.cstm-addtocart-btn input`);
        // Check if newValue is empty or does not contain any digits (numbers)
        hiddenInput.val(newValue);
        localStorage.setItem(`bundle ${productId}`, `${productCount[productId]}&&true`);
      }
    }
    // alert(`Total Products Added: ${totalProductsAdded}`);
    // Remove 'new-class' from all .cstm-tab-btn elements and add to the clicked element
    $('#create-your-bundle .cstm-tab-btn').removeClass('new-class');
    $(this).addClass('new-class');
    nextTarget();
  });
  // Function to load stored values from local storage
  function loadStoredValues() {
    $(document).find('.quantity-input').each(function () {
      var productId = $(this).attr('data-id');
      var storedValue = localStorage.getItem(`bundle ${productId}`);

      if (storedValue) {
        var parts = storedValue.split('&&');
        var quantity = parts[0];
        var checked = parts[1] === 'true';
        if (!(quantity == 0)) {
          $(this).val(quantity).attr('value', quantity);
          var hiddenInput = $(`.product-block.col_bundle_sec[data-id="${productId}"] .cs-line-item-property__field.cstm-addtocart-btn input`);
          var newValue = `${quantity}*${productId}`;
          hiddenInput.val(newValue);
          $(document).find(`.qtybox:has([data-id="${productId}"])`).hide();
        }

        if (quantity > 0) {
          $(document).find(`.qtybox:has([data-id="${productId}"])`).show();
          $(document).find(`.cstm-addtocart-btn:has([dataval="${productId}"])`).hide();
          $(document).find(`.cstm-addtocart-btn:has([dataval="${productId}"]) input`).prop('checked', checked);
        }
      }
    });
  }
  function clearPreviousTabValues() {
    $(document).find('.quantity-input').each(function () {
      var productId = $(this).attr('data-id');
      localStorage.removeItem(`bundle ${productId}`);
    });
  }

  $(document).on('click', '#create-your-bundle .cstm-addtocart-btn', function () { // DELEGATED 2026-09-01: same reason
    var $button = $(this);
    var $productBlock = $button.closest('.product-block.col_bundle_sec');
    var productId = $productBlock.data('id');
    var quantity = parseInt($productBlock.find('.quantity-selector').val());
    var quantityInput = $(`.quantity-input[data-id="${productId}"]`);
    if (quantityInput.length > 0) {
      quantityInput.val(quantity);
    }
    var hiddenInput = $productBlock.find('.cs-line-item-property__field.cstm-addtocart-btn input');
    // var newValue = `${quantity}*${$productBlock.find('.qtybox').attr('data-title')}`;
    // ==================================== code by (R) start ======================================//
    if (quantity != 0) {
      var newValue = `${quantity}*${$productBlock.find('.qtybox').attr('data-title')}`;
    }
    // ==================================== code by (R) End ======================================//
    if (newValue === '' || !/\d/.test(newValue)) {
      hiddenInput.val('');
    } else {
      hiddenInput.val(newValue);
    }
  });

  // localstorage set and get
  function loadStoredData() {
    $('.cstm-addtocart-btn input').each(function () {
      var itemHandle = $(this).attr('dataval');
      var storedData = localStorage.getItem(`bundle ${itemHandle}`);
      if (storedData) {
        var storedDataParts = storedData.split('&&');
        if (storedDataParts.length === 2) {
          var storedDataQty = storedDataParts[0];
          var storedDataInput = storedDataParts[1];
          if (!(storedDataQty == 0)) {
            $(this).closest('.ITG_Product_description').find('.qtybox').show();
            $(this).closest('.cstm-addtocart-btn').hide();
            apendData($(this), 'onload');
            $(document).find(`.qtybox input[data-id='${itemHandle}']`).val(storedDataQty).attr('value', storedDataQty);
            nextTarget();
          }
        }
      }
    });
  }

  $(document).on('click', '.ClosePopup', function () {
    $(document).find('.WarningAlertPopup').hide();
  });
  // $(document).on("click", ".custom-add-to_cart.add-to_cart-disabled", function(e) {
  //     e.preventDefault();

  //     var form = $(this).closest('form'); // Get the closest form
  //     var formData = form.serializeArray(); // Serialize form data including line item properties as an array

  //     // Loop through all input fields within the div and add their values to formData
  //     $('.cs-line-item-property__field input').each(function() {
  //         var inputName = $(this).attr('name');
  //         var inputValue = $(this).val();
  //         formData.push({ name: inputName, value: inputValue });
  //     });
  //  // Set quantity to 1 if not already set
  //     var quantityInput = form.find('input[name="quantity"]');
  //     if (quantityInput.length > 0 && quantityInput.val() !== '1') {
  //         formData.push({ name: 'quantity', value: '1' });
  //     }
  //     $.ajax({
  //         type: 'POST',
  //         url: '/cart/add.js',
  //         dataType: 'json',
  //         data: $.param(formData), // Convert the array back to a query string
  //         success: function() {
  //             setTimeout(function () {
  //                 window.location = "/checkout";
  //             }, 1000);
  //         },
  //         error: function(XMLHttpRequest, textStatus) {
  //             var response = JSON.parse(XMLHttpRequest.responseText);
  //             // alert(response.description); // Show error message to the user
  //         }
  //     });  
  // });

  // Bundle-side equivalent of theme.js's .added-notice modal (theme.js ~L4210).
  // Theme's ProductForm handler can't be reused: it expects a <variant-picker>
  // element, but the bundle renders cstm-variant-picker (no web component).
  // Mobile post-add choice (Zack): a clean, on-brand "what next?" dialog — Go to Cart
  // or Keep Shopping — with an easy X and tap-anywhere-outside to dismiss. Replaces
  // the theme's added-notice popup on PHONES ONLY (desktop keeps the theme one).
  function showMobileAddedChoice(itemData) {
    var m = document.getElementById('bb-added-choice');
    if (!m) {
      m = document.createElement('div');
      m.id = 'bb-added-choice';
      m.innerHTML =
        '<div class="bb-ac-card">' +
          '<button type="button" class="bb-ac-x" aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg></button>' +
          '<div class="bb-ac-check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="5 13 10 18 19 7"></polyline></svg></div>' +
          '<div class="bb-ac-title">Bundle added to your cart!</div>' +
          '<a class="bb-ac-go" href="/cart">Go to Cart</a>' +
          '<button type="button" class="bb-ac-stay">Keep Shopping</button>' +
        '</div>';
      document.body.appendChild(m);
      m.addEventListener('click', function (e) {
        if (e.target === m || (e.target.closest && (e.target.closest('.bb-ac-x') || e.target.closest('.bb-ac-stay')))) {
          m.classList.remove('is-open');
        }
      });
    }
    m.classList.add('is-open');
  }

  function showBundleAddedNotice($form, itemData) {
    if (window.matchMedia && window.matchMedia('(max-width: 767.98px)').matches) {
      showMobileAddedChoice(itemData);
      return;
    }
    if (!window.theme || !theme.strings || !theme.Shopify) return;
    var $productDetail = $form.closest('[data-product-id]');
    var productId = parseInt($productDetail.attr('data-product-id'), 10);
    if (!productId) return;

    theme.productData = theme.productData || {};
    if (!theme.productData[productId]) {
      var $json = $('.ProductJson-' + productId);
      if (!$json.length) return;
      try { theme.productData[productId] = JSON.parse($json.html()); } catch (e) { return; }
    }
    var product = theme.productData[productId];

    // Line items = chosen Wigglitz from the bundle's properties[] inputs.
    var lineItems = {};
    $form.find('input[name^="properties["]').each(function () {
      var name = $(this).attr('name');
      var val = $(this).val();
      if (!val) return;
      var key = name.split('[')[1].split(']')[0];
      if (key && key[0] !== '_') lineItems[key] = val;
    });
    // Collapse the character list into a tidy "N Wigglitz — view list" toggle so the
    // popup isn't a wall of names. Same markup/classes as the cart page (sections/
    // main-cart.liquid) so it inherits the .bundle-contents styling. Values are
    // "qty*Title" — parse the qty so multiples show "× N".
    var lineItemsHTML = '';
    if (Object.keys(lineItems).length) {
      var temp = document.createElement('span');
      var figTotal = 0;
      var rows = '';
      for (var k in lineItems) {
        var raw = String(lineItems[k]);
        var n = (raw.indexOf('*') > -1) ? (parseInt(raw.split('*')[0], 10) || 1) : 1;
        figTotal += n;
        temp.innerText = k;
        rows += '<li>' + temp.innerHTML + (n > 1 ? ' <span class="bundle-contents__qty">&times;' + n + '</span>' : '') + '</li>';
      }
      lineItemsHTML = '<details class="bundle-contents bundle-contents--popup">'
        + '<summary class="bundle-contents__summary">' + figTotal + ' Wigglitz — view list</summary>'
        + '<ul class="bundle-contents__list">' + rows + '</ul>'
        + '</details>';
    }

    // Image
    var imgSrc = '';
    var rawSrc = product.featured_image
      || (product.media && product.media[0] && product.media[0].preview_image && product.media[0].preview_image.src);
    if (rawSrc) {
      imgSrc = (window.slate && slate.Image && slate.Image.getSizedImageUrl)
        ? slate.Image.getSizedImageUrl(rawSrc, '200x')
        : rawSrc;
    }

    // Price for the bundle line we just added
    var priceVal = (itemData && (itemData.final_line_price != null ? itemData.final_line_price : itemData.line_price)) || 0;
    var priceHTML = '<span class="theme-money">' + theme.Shopify.formatMoney(priceVal, theme.moneyFormat) + '</span>';

    var qtyHTML = '';
    if (itemData && itemData.quantity > 1) {
      qtyHTML = ' <span class="cart-summary__quantity">' + itemData.quantity + '</span>';
    }

    var closeIcon = (theme.icons && theme.icons.close) || '&times;';
    var closeLabel = (theme.strings && theme.strings.close) || 'Close';

    $.getJSON((theme.routes.cart_url || '/cart') + '.js', function (cartData) {
      var $template = $([
        '<div class="added-notice global-border-radius added-notice--pre-reveal">',
          '<div class="added-notice__header">',
            '<span class="added-notice__title">', theme.strings.addedToCartPopupTitle, '</span>',
            '<a class="added-notice__close feather-icon" href="#" aria-label="', closeLabel, '">', closeIcon, '</a>',
          '</div>',
          '<div class="cart-summary global-border-radius">',
            '<div class="cart-summary__product">',
              (imgSrc ? '<div class="cart-summary__product-image"><img class="global-border-radius" src="' + imgSrc + '" role="presentation" alt=""></div>' : ''),
              '<div class="cart-summary__product__description">',
                '<div class="cart-summary__product-title">', product.title, qtyHTML, '</div>',
                lineItemsHTML,
                '<div class="cart-summary__price">', priceHTML, '</div>',
              '</div>',
            '</div>',
          '</div>',
          '<div class="cart-summary__footer">',
            '<div class="cart-summary__total-quantity-row">',
              '<span>', theme.strings.addedToCartPopupItems, '</span>',
              '<span>', cartData.item_count, '</span>',
            '</div>',
            '<div class="cart-summary__total-price-row large-text">',
              '<span>', theme.strings.addedToCartPopupSubtotal, '</span>',
              '<span class="theme-money">', theme.Shopify.formatMoney(cartData.total_price, theme.moneyFormatWithCodeForCartPreference), '</span>',
            '</div>',
            '<a href="', (theme.routes.cart_url || '/cart'), '" class="btn btn--primary btn--small btn--fullwidth cart-summary__button">', theme.strings.addedToCartPopupGoToCart, '</a>',
          '</div>',
        '</div>'
      ].join(''));

      $template.appendTo('body');
      $template.find('.added-notice__close').on('click', function () {
        var $t = $(this).closest('.added-notice').addClass('added-notice--pre-destroy');
        setTimeout(function () { $t.remove(); }, 500);
        return false;
      });
      setTimeout(function () { $template.removeClass('added-notice--pre-reveal'); }, 10);
      if (theme.addedToCartNoticeHideTimeoutId) clearTimeout(theme.addedToCartNoticeHideTimeoutId);
      theme.addedToCartNoticeHideTimeoutId = setTimeout(function () {
        $template.find('.added-notice__close').trigger('click');
      }, 5000);
    });
  }

  $(document).on("click", ".custom-add-to_cart.add-to_cart-disabled", function (e) {
    e.preventDefault();

    $('.custom-add-to_cart').css("opacity", "0.6");
    $('.custom-add-to_cart').text("Adding to Cart");

    var form = $(this).closest('form');

    // Total characters selected (real picks + any Mystery Fill).
    var totalSelected = 0;
    $('.ITG_Product_description .qtybox input').each(function () {
      totalSelected += (parseInt($(this).val()) || 0);
    });

    // SAFETY NET (money): for fixed sizes (<=50) the variant that will ACTUALLY be
    // charged is whatever is in the cart form's id field. The character count MUST
    // equal that variant's size, or the price wouldn't match the bundle. We read
    // the FORM id (not the highlighted box) so a display desync can never let a
    // mismatched bundle through.
    if (totalSelected <= 50) {
      var chargeId = $('form[action*="/cart/add"] [name="id"]').val();
      var chargeTier = parseInt(($('.option-selector__btns input[type="radio"][data-variant-id="' + chargeId + '"]').val() || '').replace(/[^0-9]/g, '')) || 0;
      if (chargeTier && totalSelected !== chargeTier) {
        alert("Your bundle isn't full yet — please add " + (chargeTier - totalSelected) + " more (or hit Mystery Fill) before checking out.");
        $('.custom-add-to_cart').css('opacity', '').text('Add to Cart');
        return;
      }
    }

    // Shared finish step: refresh header cart, show added-notice, reset bundle.
    function finishAdd(itemData) {
      $('.custom-add-to_cart').text("Added to Cart");
      var onAddToCart = (window.theme && theme.settings && theme.settings.onAddToCart) || 'ajax';
      var cartUrl = (window.theme && theme.routes && theme.routes.cart_url) || '/cart';
      if (onAddToCart === 'add_and_redirect' || onAddToCart === 'go_to_cart') {
        // Clear bundle state so a return visit starts empty.
        $('.itg_remove').trigger('click');
        setTimeout(function () { window.location = cartUrl; }, 1000);
        return;
      }
      // ajax: refresh header cart, show theme's added-notice modal
      if (window.theme && theme.routes && theme.routes.search_url) {
        $.get(theme.routes.search_url, function (data) {
          var $parsed = $($.parseHTML('<div>' + data + '</div>'));
          ['.page-header .header-cart', '.docked-navigation-container .header-cart'].forEach(function (sel) {
            var $newCart = $parsed.find(sel).clone();
            if ($newCart.length) $(sel).replaceWith($newCart);
          });
        });
      }
      showBundleAddedNotice(form, itemData);
      $('.itg_remove').trigger('click');
      setTimeout(function () {
        $('.custom-add-to_cart').css('opacity', '').text('Add to Cart');
      }, 1500);
    }

    // 50+ : TWO clean line items — the real "50 Wigglitz" bundle variant at its
    // own store price, plus the hidden per-unit "Extra Wigglitz" product for the
    // portion beyond 50. This works for ANY bundle price (e.g. $74.99, where the
    // old single-line "total x per-unit" math only worked because $60 = 50 x $1.20
    // exactly). All character names ride on the bundle line, so fulfillment sees
    // the full pick list in one place. If the bundle variant id can't be read,
    // falls back to the legacy single-line add (correct while 50-pack = 50 x extra price).
    if (totalSelected > bbTierQ(3)) {
  // 50+ : ONE "50 Wigglitz" bundle line carries the $74.99 and ALL the picks in
  // `_bundle_skus` (Cart Transform hides them at checkout; ShipHero still sees every
  // SKU). The over-50 surcharge can't be folded into that line (Shopify blocks a
  // price INCREASE inside a bundle), so it rides on its own single "Additional
  // Wigglitz (Beyond 50)" line at $1.50 each. No more individual free Wigglitz.
  var skuList50 = [];
  var namesList50 = [];
  $('.cs-line-item-property__field input').each(function () {
    var $el = $(this);
    var v = $el.val();
    if (!v) return;
    var qtyMatch = String(v).match(/^(\d+)\*/);
    var qty = qtyMatch ? (parseInt(qtyMatch[1], 10) || 1) : 1;
    var variantId = parseInt($el.attr('data-variant-id'), 10);
    var nm50 = $el.attr('title') || '';
    if (variantId) { for (var q50 = 0; q50 < qty; q50++) { skuList50.push(variantId); } }
    if (nm50) { namesList50.push(qty > 1 ? (qty + '× ' + nm50) : nm50); }
  });
  // ARM B OFFER 6: top tier = 64, extras = "Additional Wigglitz (Beyond 64)" $1.33.
  var bundleVariantId = parseInt($('.option-selector__btns input[value="' + bbTierQ(3) + ' Wigglitz"]').attr('data-variant-id'), 10);
  var extrasQty = totalSelected - bbTierQ(3);
  var bbExtrasLabel = 'Additional Wigglitz (Beyond ' + bbTierQ(3) + ')';
  var cartItems;
  if (bundleVariantId) {
    cartItems = [
      { id: bundleVariantId, quantity: 1, properties: { _bundle_skus: skuList50.join(','), _bundle_names: namesList50.join(', ') } },
      { id: 53932258853178, quantity: extrasQty, properties: (function () { var p = {}; p[bbExtrasLabel] = extrasQty + ' beyond the first ' + bbTierQ(3); return p; })() }
    ];
  } else {
    cartItems = [{ id: 53932258853178, quantity: totalSelected, properties: { _bundle_skus: skuList50.join(','), _bundle_names: namesList50.join(', ') } }];
  }
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify({ items: cartItems }),
    success: function (resp) {
      var bundleItem = resp && resp.items ? (resp.items.filter(function (it) { return it.variant_id === bundleVariantId || it.variant_id === 53932258853178; })[0] || resp.items[resp.items.length - 1]) : resp;
      finishAdd(bundleItem);
    },
    error: function (XMLHttpRequest) { try { JSON.parse(XMLHttpRequest.responseText); } catch (err) {} }
  });
  return;
}

// <=50: add ONE bundle line, tagged with the picked SKUs in a hidden
// `_bundle_skus` property. The store's Cart Transform ("bundle-expand") splits
// that single line into the individual Wigglitz SKUs at checkout so ShipHero
// picks each one, while the price stays on the bundle line and NO per-item
// price is ever shown to the customer.
var bundleVariantId2 = parseInt(form.find('[name="id"]').val(), 10);
var bundleQty = parseInt(form.find('[name="quantity"]').val(), 10) || 1;
var skuList2 = [];
var namesList2 = [];
$('.cs-line-item-property__field input').each(function () {
  var $el = $(this);
  var v = $el.val();
  if (!v) return;
  var qtyMatch = String(v).match(/^(\d+)\*/);
  var qty = qtyMatch ? (parseInt(qtyMatch[1], 10) || 1) : 1;
  var variantId = parseInt($el.attr('data-variant-id'), 10);
  var nm2 = $el.attr('title') || '';
  if (variantId) { for (var qi2 = 0; qi2 < qty; qi2++) { skuList2.push(variantId); } }
  if (nm2) { namesList2.push(qty > 1 ? (qty + '× ' + nm2) : nm2); }
});
// `_bundle_names` (hidden `_` property) is the tidy pick list the cart page shows
// in a collapsed dropdown; `_bundle_skus` is what the Cart Transform splits on.
var cartItems2 = [{ id: bundleVariantId2, quantity: bundleQty, properties: { _bundle_skus: skuList2.join(','), _bundle_names: namesList2.join(', ') } }];
$.ajax({
  type: 'POST',
  url: '/cart/add.js',
  dataType: 'json',
  contentType: 'application/json',
  data: JSON.stringify({ items: cartItems2 }),
  success: function (resp) {
    var bundleItem = resp && resp.items ? (resp.items.filter(function (it) { return it.variant_id === bundleVariantId2; })[0] || resp.items[0]) : resp;
    finishAdd(bundleItem);
  },
  error: function (XMLHttpRequest) { try { JSON.parse(XMLHttpRequest.responseText); } catch (err) {} }
});
  });

  // jquery for search product in custom search bar on bundle product page
  $("input#B_open-search-bar").on("keyup", function () {
    var value = $(this).val().toLowerCase();
    // Tabs mode: while there's a query, suspend the per-collection filter so matches show across ALL collections.
    document.getElementById('create-your-bundle').classList.toggle('bb-searching', value.length > 0);
    $(".product-block.col_bundle_sec").each(function () {
      var match = $(this).attr('sp_title').toLowerCase().indexOf(value) > -1;
      $(this).css('display', match ? '' : 'none');
    });
    // Collapse groups whose products were all hidden by the search match.
    // Read inline style directly — getComputedStyle on a child of a
    // display:none parent is not reliable across browsers.
    $('.bundle-collection-group').each(function () {
      var $group = $(this);
      var anyVisible = $group.find('.product-block.col_bundle_sec').filter(function () {
        return this.style.display !== 'none';
      }).length > 0;
      $group.css('display', anyVisible ? '' : 'none');
    });
  });
  // on click search bar fillter to fadeToggle filter slider 
  $('.src_filter_tag_flx').click(function (event) {
    event.stopPropagation();
    $('.searc_bar_filter_tg').fadeToggle();
  });
  $('body').click(function (event) {
    if (!$(event.target).closest('.searc_bar_filter_tg, .src_filter_tag_flx').length) {
      $('.searc_bar_filter_tg').hide();
    }
  });

  // jquery for update product according to filter tag 
  $('.searc_bar_filter_tg').click(function (event) {
    event.stopPropagation();
  });

  $(".searc_bar_filter_tg ul.product-tags li").on("click", function (e) {
    var $li = $(this);
    var dataFilter = $li.attr('data-filter') || '';
    var isAll = dataFilter === 'all';
    var li_tag = isAll ? '' : (($li.attr('Pgtag') || '').toLowerCase());
    var li_text = $li.text().replace('🔒', '').trim();

    // Check if locked and not unlocked (skips the All Collections item — never locked).
    // Per series since 2026-09-25: the tag's series may be open via its own code or time.
    var lockSeries = $li.attr('data-lock-series') || null;
    if ($li.data('locked') && typeof window.wigglitzLockIsUnlocked === 'function' && !window.wigglitzLockIsUnlocked(lockSeries)) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof window.wigglitzLockSetPendingAction === 'function') {
        window.wigglitzLockSetPendingAction({
          type: 'filter',
          element: this
        });
      }
      if (typeof window.wigglitzLockOpenModal === 'function') {
        window.wigglitzLockOpenModal(lockSeries);
      }
      return false;
    }

    // Sync dropdown active state
    $li.closest('.product-tags').find('li').removeClass('is-active');
    $li.addClass('is-active');

    // Update Filters pill label
    $li.closest('.searc_bar_filter').find('.src_filter_tag_flx span').text(li_text);

    var $grid = $('.cstm-bundle-product-grid');
    var $allProducts = $('.product-block.col_bundle_sec');
    var $allGroups = $('.bundle-collection-group');

    if (isAll) {
      // Show everything; sticky headers come back via the CSS class.
      // Use inline display:'' (not jQuery .show()) so the CSS `display: flex`
      // on product cards wins — jQuery 3's .show() forces inline `display: block`
      // on cascade-hidden children, which would override the flex layout.
      $allProducts.css('display', '');
      $allGroups.css('display', '');
      $grid.removeClass('is-filtered');
    } else {
      // Show only products carrying this tag (substring match on product_tag)
      $allProducts.filter(function () {
        var product_tag = ($(this).attr('product_tag') || '').toLowerCase();
        return product_tag.indexOf(li_tag) > -1;
      }).css('display', '');

      $allProducts.filter(function () {
        var product_tag = ($(this).attr('product_tag') || '').toLowerCase();
        return product_tag.indexOf(li_tag) === -1;
      }).css('display', 'none');

      // Collapse groups that ended up empty (the matched product may live in
      // any group because of first-match bucketing).
      // Read inline style directly — getComputedStyle on a child of a
      // display:none parent is not reliable across browsers.
      $allGroups.each(function () {
        var $group = $(this);
        var anyVisible = $group.find('.product-block.col_bundle_sec').filter(function () {
          return this.style.display !== 'none';
        }).length > 0;
        $group.css('display', anyVisible ? '' : 'none');
      });

      // CSS class hides every header while a single collection is filtered.
      $grid.addClass('is-filtered');
    }

    $('.searc_bar_filter_tg').hide();

  });
  // on click view-details button show-hide overlap popup on product grid
  $('.view-details a').click(function () {
    $(this).closest('.product-block.col_bundle_sec').addClass('open-popup');
  });
  $('.popupclose').click(function () {
    $(this).closest('.product-block.col_bundle_sec').removeClass('open-popup');
  });
  $('.mobile_sc_arrow').click(function () {
    $(this).closest('.cstm-bundle-content').toggleClass('open-popupBar');
    if ($(".open-popupBar").length > 0) {
      $('body').addClass('Bnd-overflow-hiddan')
    } else {
      $('body').removeClass('Bnd-overflow-hiddan')
    }
  });
  // NOTE: the OLD duplicate swipe-down-to-close handler that used to live here was removed. It double-fired
  // with the canonical drag-down-to-close gesture (defined earlier), so a single pull-down clicked the close
  // arrow twice — closing the drawer, then toggling it right back open ("close for a split second and reopen").
  $(document).on("click", "span.qtyminus", function () {
    var numItems = $('.product-block.col_bundle_sec.active').length;
    //alert(numItems);
    if (numItems === 0) {
      $('body').removeClass('Bnd-overflow-hiddan');
    }
  });
  // $('.cs-line-item-property__field.cstm-addtocart-btn').click(function () {
  function durationSlider() {
    setInterval(function () {
      var allQuantitiesZero = true;

      // Check if all quantity-selector values are 0
      $('.quantity-selector').each(function () {
        if ($(this).val() != 0) {
          allQuantitiesZero = false;
          return false; // Exit loop early if a non-zero quantity is found
        }
      });

      if ($('.cstm-bundle-product-grid .cstm-addtocart-btn input').is(':checked') || !allQuantitiesZero) {
        $('.cstm-bundle-main').addClass('popSlidbox');
      } else {
        // Empty bundle. This used to force-close the drawer every 50ms, which made the new empty
        // drawer impossible to keep open (open → slammed shut within 50ms → the "flash + revert").
        // Now: only run the empty cleanup while the drawer is CLOSED; if the shopper has opened the
        // empty drawer to read the "your Wigglitz will appear here" note, leave it completely alone (Zack).
        if (!$('.cstm-bundle-main .cstm-bundle-content').hasClass('open-popupBar')) {
          $('.cstm-bundle-main').removeClass('popSlidbox');
          $('.cstm-tab-btn').removeClass('new-class');
          $('body').removeClass('Bnd-overflow-hiddan');
        }
      }
    }, 50);
  }
  durationSlider();
  // });


  // ...........Aaaaaaa..........


  $(document).on("click", ".custom_addon-item .Remove", function () {
    var dta = $('.add_extra_content_btn input').attr("id");
    $('.new-product.col_bundle_sec.addon_product-box').remove();
    $('.add_extra_content_btn input').prop('checked', false);
    var variant_id = $(this).closest('.new-product.col_bundle_sec.addon_product-box').attr('first_id');
    $(this).closest('.new-product.col_bundle_sec.addon_product-box').remove();
    removeAddonProductFromLocalStorage(variant_id);
  });

  $(document).on("click", ".addonproductquantity span", function () {
    var quantityInput = $(this).parent().find('.addon-number');
    var currentQuantity = parseInt(quantityInput.val(), 10);
    if ($(this).hasClass('addon-plus')) {
      quantityInput.val(currentQuantity + 1);
    } else if ($(this).hasClass('addon-minus')) {
      if (currentQuantity > 1) {
        quantityInput.val(currentQuantity - 1);
      } else {
        $(this).closest('.new-product.col_bundle_sec.addon_product-box').remove();
        var bundleSec = $(this).closest('.col_bundle_sec');
        var productId = bundleSec.attr('data-id');
        return;
      }
    }

  });
  // Function to save addon product data to local storage
  function saveAddonProductToLocalStorage(variant_id, addon_productImage, addonproductTitle) {
    var addonProductData = {
      variant_id: variant_id,
      addon_productImage: addon_productImage,
      addonproductTitle: addonproductTitle
    };
    localStorage.setItem('addonProduct_' + variant_id, JSON.stringify(addonProductData));
  }
  // Function to remove addon product data from local storage
  function removeAddonProductFromLocalStorage(variant_id) {
    localStorage.removeItem('addonProduct_' + variant_id);
  }
  $('.add_extra_content_btn input').on('change', function (evt) {
    evt.preventDefault();
    var dta = $(this).attr("id");
    var addon_productImage = $('.add_extra_media').attr('addon_img');
    var addonproductTitle = $('.add_extra_content h3').text();
    var variant_id = $(this).attr("data-id");
    var remove_item = 'Remove Item';
    var data = {
      id: variant_id,
      quantity: 1
    };

    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function () {
        if ($('#' + dta).is(':checked')) {
          saveAddonProductToLocalStorage(variant_id, addon_productImage, addonproductTitle);
          var newProductHtml = `
                        <div class="new-product col_bundle_sec addon_product-box" first_id="${variant_id}">
                            <div class="productimage-box test add to cart">
                                <img src="${addon_productImage}" alt="Product Image">
                                  <div class="custom_addon-item">
                                        <h3>${addonproductTitle}</h3>
                                        <div class="Remove">${remove_item}</div>
                                  </div>
                            </div>
                          
                        </div>
                    `;
          $(".bundle_cart_main_sec").append(newProductHtml);
        } else {
          $(this).parent().parent().removeClass('active');
          $('.new-product.col_bundle_sec.addon_product-box[first_id="' + variant_id + '"]').remove();
          removeAddonProductFromLocalStorage(variant_id);
        }
      },
      error: function (xhr, status, error) {
        console.error('Error adding item to cart:', status, error);
      }
    });
  });
  // Loop through local storage items and recreate addon products
  for (var i = 0; i < localStorage.length; i++) {
    var key = localStorage.key(i);
    if (key.startsWith('addonProduct_')) {
      var variant_id = key.replace('addonProduct_', '');
      var addonProductData = JSON.parse(localStorage.getItem(key));
      if (addonProductData) {
        var newProductHtml = `
                    <div class="new-product col_bundle_sec addon_product-box" first_id="${addonProductData.variant_id}">
                        <div class="productimage-box test add to cart">
                            <img src="${addonProductData.addon_productImage}" alt="Product Image">
                            <div class="custom_addon-item">
                                <h3>${addonProductData.addonproductTitle}</h3>
                                <div class="Remove">Remove Item</div>
                            </div>
                        </div>
                    </div>
                `;
        $(".bundle_cart_main_sec").append(newProductHtml);
      }
    }
  }
  // Hide the price text in the labels
  // $('.option-selector__btns.Color .opt-label').each(function() {
  //   // Split the label text and keep only the first part (before the price)
  //   var labelText = $(this).text().split('$')[0];
  //   $(this).text(labelText.trim());
  // });

  $('.option-selector__btns.Color .opt-label').each(function () {
    // Split the label text and keep only the first part (before the price)
    var labelText = $(this).text().split('$')[0].trim();

    // Remove the hyphen (-) if it exists at the end of the labelText
    labelText = labelText.replace(/-\s*$/, '');

    // Set the updated text back to the label
    $(this).text(labelText);
  });

});

// ==================================== code by (R) start ======================================//
document.addEventListener("DOMContentLoaded", function () {
  const check_out_btn = document.querySelector('.cart-submit');
  if (check_out_btn) {
    check_out_btn.addEventListener('click', () => localStorage.clear());
  }
});
// ----------- this code for reload page from checkout page to back on other page  ----------
(function () {
  window.onpageshow = function (event) {
    if (event.persisted) {
      window.location.reload();
    }
  };
})();

// -----------
// Replay cc-animate animations on every viewport entry.
// Theme's observer (theme.js) triggers once then unobserves. This IIFE runs a
// second IntersectionObserver that toggles `cc-animate-in` on enter/leave so
// animations re-play every time the element scrolls back into view.
// No modification to theme.js required.
// -----------
(function () {
  if (!('IntersectionObserver' in window) || !('MutationObserver' in window)) return;

  var replay = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var el = entry.target;
      if (entry.isIntersecting) {
        if (!el.classList.contains('cc-animate-in')) {
          el.classList.add('cc-animate-in');
        }
      } else {
        el.classList.remove('cc-animate-in');
      }
    });
  });

  var observed = new WeakSet();
  function observeAll() {
    document.querySelectorAll('[data-cc-animate]').forEach(function (el) {
      if (observed.has(el)) return;
      observed.add(el);
      replay.observe(el);
    });
  }

  function start() {
    if (!document.body.classList.contains('cc-animate-enabled')) return;
    observeAll();
    new MutationObserver(observeAll).observe(document.body, {
      subtree: true,
      childList: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

// ==================================== code by (R) End ======================================//

// -----------
// Cart guard: the 50+ bundle's "Additional Wigglitz (Beyond 50)" top-up line
// must never survive in the cart without its parent bundle line. Alone it's
// N Wigglitz at the small per-unit price with no character list, so removing
// the bundle line and keeping the top-up would let an order through at a
// fraction of the real price. Liquid (main-cart.liquid) already hides the
// top-up line's remove control; this script covers the two remaining paths:
//   1) Removing a 50-pack bundle line also removes every top-up line.
//   2) On cart-page load, orphaned top-up lines (created by any other means)
//      are removed automatically before checkout can be reached, with the
//      checkout buttons disabled while that heal runs.
// Uses line-item keys (stable) rather than line numbers (shift on removal).
// -----------
(function () {
  var EXTRAS_LINE = '.bb-extras-line';
  var BUNDLE_LINE = '.bb-bundle-line';

  function isFiftyPack($line) {
    // ARM B OFFER 6 (2026-08-26): top tier is the 64-pack. '50'/'65' stay for any
    // legacy cart still in flight; '64' is the live one. Dropping a tier prefix here
    // disowns that tier's top-up and strobe-loops the cart (the 8/20 bug).
    var t = ($line.attr('data-variant-title') || '');
    return t.indexOf('50') === 0 || t.indexOf('65') === 0 || t.indexOf('64') === 0;
  }

  function removeByKeys(updates) {
    return jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify({ updates: updates })
    });
  }

  jQuery(function ($) {
    // 1) Removing the 50-pack bundle line also clears the top-up lines.
    $(document).on('click', BUNDLE_LINE + ' a.quantity__remove', function (e) {
      var $extras = $(EXTRAS_LINE);
      if (!$extras.length) { return; } // nothing to guard: default remove
      var $line = $(this).closest('.cart-item-container');
      if (!isFiftyPack($line)) { return; } // smaller bundles never own a top-up
      e.preventDefault();
      var updates = {};
      updates[$line.attr('data-key')] = 0;
      // Clear the top-ups only when this was the LAST 50-pack line in the cart.
      var otherFifties = $(BUNDLE_LINE).not($line).filter(function () {
        return isFiftyPack($(this));
      }).length;
      if (otherFifties === 0) {
        $extras.each(function () { updates[$(this).attr('data-key')] = 0; });
      }
      removeByKeys(updates).always(function () { window.location.href = '/cart'; });
    });

    // 2) Orphan healer on the cart page.
    var $orphans = $(EXTRAS_LINE);
    if (!$orphans.length) { return; }
    var hasParent = $(BUNDLE_LINE).filter(function () {
      return isFiftyPack($(this));
    }).length > 0;
    if (hasParent) { return; }
    $('.cart-submit, .additional-checkout-buttons')
      .css({ 'pointer-events': 'none', opacity: 0.4 });
    var updates = {};
    $orphans.each(function () { updates[$(this).attr('data-key')] = 0; });
    // Reload ONLY on success — .always(reload) strobe-looped forever when
    // /cart/update failed (bot-walled sessions): fail -> reload -> fail...
    removeByKeys(updates)
      .done(function () { window.location.reload(); })
      .fail(function () { /* leave checkout disabled; no reload loop */ });
  });
})();
// First-collection tagger (Zack, 2026-07-10 v2): the chip bar's bottom border is the ONE permanent divider
// (a scroll-toggled border changed the bar's height mid-scroll = the glitchy snap, and briefly showed two
// lines). CSS removes the FIRST collection card's own top edge so it starts flush under that line - this
// just tags which card is first, so the styling survives any reordering of collections.
(function () {
  function init() {
    var first = document.querySelector('#create-your-bundle .cstm-bundle-product-grid .bundle-collection-group');
    if (first) { first.classList.add('bb-first-group'); }
  }
  if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();
// Klaviyo email-popup manners: MOVED ENTIRELY to sections/main-custom-product.liquid (2026-07-10), inline
// with the gate <style> it depends on. Reason: CDN byte-staleness kept serving this file at older versions
// whose aggressive dismiss handlers closed the popup on ANY touch - paired with a fresh page, the popup
// flashed and instantly vanished. ALL popup gate/release/dismiss logic must live in that ONE liquid file;
// never reintroduce any of it here.
// Tap-to-wiggle TEACHER BANNER (Zack picked idea 1 of 3, 2026-07-13; demo/coach experiments removed):
// one readable line above the characters teaches the wiggle; the per-card pills are icon-only squiggles.
// The banner fades + collapses away the FIRST time the shopper taps a character ("then they understand")
// and stays away for the rest of the visit (sessionStorage). Mobile only; identical on every theme (NOT
// part of the A/B test - both arms carry it).
(function () {
  function init() {
    if (!document.body || document.body.id !== 'create-your-bundle') return;
    if (!window.matchMedia || !window.matchMedia('(max-width: 767px)').matches) return;
    document.body.classList.add('bbhint-banner'); // per-card pills go icon-only on mobile
    var KEY = 'bb-wiggle-understood';
    try { if (sessionStorage.getItem(KEY) === '1') return; } catch (e) {}
    var grid = document.querySelector('#create-your-bundle .cstm-bundle-product-grid');
    if (!grid) return;
    var b = document.createElement('div');
    b.className = 'bb-hint-banner';
    b.innerHTML = '👆 <b>Tap any Wigglitz</b> to see it wiggle!';
    grid.insertBefore(b, grid.firstChild);
    // STICKY under the collections chip bar while they browse (Zack): the bar's height varies with
    // wrapping, so measure it and pin the banner just beneath; re-measure on resize/rotation.
    var bbChipBar = document.querySelector('#create-your-bundle .cst_bndl_search_mn');
    var bbPlace = function () {
      b.style.top = ((bbChipBar && bbChipBar.offsetHeight ? bbChipBar.offsetHeight : 80) + 6) + 'px';
    };
    bbPlace();
    window.addEventListener('resize', bbPlace, { passive: true });
    setTimeout(bbPlace, 600);
    // Dismiss only on a REAL tap on a character - a scroll that merely STARTS on a character (finger
    // travels) must not count (Zack). Track pointerdown, judge on pointerup: <=12px travel, <=600ms.
    var bbDownAt = null;
    var onDown = function (e) {
      bbDownAt = (e.target && e.target.closest && e.target.closest('.product-block__image-container'))
        ? { x: e.clientX, y: e.clientY, t: Date.now() } : null;
    };
    var onUp = function (e) {
      if (!bbDownAt) return;
      var wasTap = Math.abs(e.clientX - bbDownAt.x) <= 12 && Math.abs(e.clientY - bbDownAt.y) <= 12 && (Date.now() - bbDownAt.t) <= 600;
      bbDownAt = null;
      if (!wasTap) return;
      if (!e.target || !e.target.closest || !e.target.closest('.product-block__image-container')) return;
      document.removeEventListener('pointerdown', onDown, true);
      document.removeEventListener('pointerup', onUp, true);
      try { sessionStorage.setItem(KEY, '1'); } catch (err) {}
      b.classList.add('bb-hint-banner--out');
      setTimeout(function () { if (b.parentNode) b.parentNode.removeChild(b); }, 800);
    };
    document.addEventListener('pointerdown', onDown, true);
    document.addEventListener('pointerup', onUp, true);
  }
  if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();
// Size-picker WATCHDOG (Zack 2026-07-13): the picker sizing lives in the page's inline script, and Shopify
// caches pages hard - a stale cached page (pre-fix) leaves the picker UNSIZED after a reload-while-scrolled
// (giant edge-to-edge tiles). This file always ships fresh, so: ~1.5s after load, if the intro still has no
// computed height, size it here with the same math as the inline fit(). No-op when the page did its job.
(function () {
  function init() {
    if (!document.body || document.body.id !== 'create-your-bundle') return;
    if (!window.matchMedia || !window.matchMedia('(max-width: 767px)').matches) return;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      var wrap = document.querySelector('#create-your-bundle .bb-mintro');
      if (!wrap) { if (tries > 40) clearInterval(iv); return; }
      if (wrap.style.height) { clearInterval(iv); return; }  // already sized - nothing to do
      if (tries < 6) return;                                 // give the inline script ~1.5s to act first
      clearInterval(iv);
      var vh = Math.min(window.innerHeight, document.documentElement.clientHeight || window.innerHeight);
      var top = wrap.getBoundingClientRect().top + (window.pageYOffset || 0);
      var avail = Math.max(320, Math.round(vh - top));
      document.body.style.setProperty('--bbf', '1');
      wrap.style.height = 'auto';
      // Width parity w/ arm A (ported 2026-08-25; Davis's accepted 8/20 fix):
      // this arm's cards carry TWO shiny perks boxes (32 + 65) vs arm A's one,
      // so raw scrollHeight over-shrinks the tiles and leaves fat side bezels.
      // Subtract the LARGEST perks box when 2+ are visible — the remainder
      // matches arm A's content, so the scale (and side gutters) match too.
      var bbPerksComp = function () {
        var boxes = wrap.querySelectorAll('.bb-tier-perks--full');
        var visible = [];
        for (var b = 0; b < boxes.length; b++) { if (boxes[b].offsetHeight) { visible.push(boxes[b].offsetHeight); } }
        if (visible.length < 2) return 0;
        return Math.max.apply(null, visible);
      };
      var f = 1;
      for (var i = 0; i < 14; i++) {
        var nat = wrap.scrollHeight - bbPerksComp();
        if (!(nat > 0)) break;
        var ratio = (avail - 2) / nat;
        if (ratio >= 0.995 && ratio <= 1.05) break;
        f = Math.min(1.25, Math.max(0.5, f * ratio));
        document.body.style.setProperty('--bbf', f.toFixed(3));
        if ((f === 1.25 && ratio > 1) || (f === 0.5 && ratio < 1)) break;
      }
      for (var s = 0; s < 6; s++) {
        if (wrap.scrollHeight - bbPerksComp() <= avail - 2 || f <= 0.5) break;
        f = Math.max(0.5, f * ((avail - 2) / (wrap.scrollHeight - bbPerksComp())));
        document.body.style.setProperty('--bbf', f.toFixed(3));
      }
      wrap.style.height = (wrap.scrollHeight <= avail - 2) ? (avail + 'px') : 'auto';
      wrap.classList.add('bb-sized');
    }, 250);
  }
  if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();
// (series-grid experiment switcher removed 2026-07-16 - option A shipped as permanent CSS in custom.css)

// (bundle pagination stitch removed 2026-09-25 - one collection per theme, none near the 250 cap, so the grid never paginates)
